// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:wght@100;400;500;600;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: currentColor; /* 2 */
}::before,
::after {
  --tw-content: '';
}/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}/*
Remove the default font size and weight for headings.
*/h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}/*
Reset links to optimize for opt-in styling instead of opt-out.
*/a {
  color: inherit;
  text-decoration: inherit;
}/*
Add the correct font weight in Edge and Safari.
*/b,
strong {
  font-weight: bolder;
}/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}/*
Add the correct font size in all browsers.
*/small {
  font-size: 80%;
}/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}sub {
  bottom: -0.25em;
}sup {
  top: -0.5em;
}/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}/*
Remove the inheritance of text transform in Edge and Firefox.
*/button,
select {
  text-transform: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}/*
Use the modern Firefox focus style for all focusable elements.
*/:-moz-focusring {
  outline: auto;
}/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/:-moz-ui-invalid {
  box-shadow: none;
}/*
Add the correct vertical alignment in Chrome and Firefox.
*/progress {
  vertical-align: baseline;
}/*
Correct the cursor style of increment and decrement buttons in Safari.
*/::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}/*
Remove the inner padding in Chrome and Safari on macOS.
*/::-webkit-search-decoration {
  -webkit-appearance: none;
}/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}/*
Add the correct display in Chrome and Safari.
*/summary {
  display: list-item;
}/*
Removes the default spacing and border for appropriate elements.
*/blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}fieldset {
  margin: 0;
  padding: 0;
}legend {
  padding: 0;
}ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}/*
Reset default styling for dialogs.
*/dialog {
  padding: 0;
}/*
Prevent resizing textareas horizontally by default.
*/textarea {
  resize: vertical;
}/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}/*
Set the default cursor for buttons.
*/button,
[role="button"] {
  cursor: pointer;
}/*
Make sure disabled buttons don't get the pointer cursor.
*/:disabled {
  cursor: default;
}/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/img,
video {
  max-width: 100%;
  height: auto;
}/* Make elements with the HTML hidden attribute stay hidden by default */[hidden] {
  display: none;
}*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}.container{
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}@media (min-width: 576px){.container{
    max-width: 576px;
  }
}@media (min-width: 768px){.container{
    max-width: 768px;
  }
}@media (min-width: 992px){.container{
    max-width: 992px;
  }
}@media (min-width: 1200px){.container{
    max-width: 1200px;
  }
}.sr-only{
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border-width: 0 !important;
}.pointer-events-none{
  pointer-events: none !important;
}.visible{
  visibility: visible !important;
}.static{
  position: static !important;
}.fixed{
  position: fixed !important;
}.absolute{
  position: absolute !important;
}.relative{
  position: relative !important;
}.sticky{
  position: sticky !important;
}.bottom-0{
  bottom: 0 !important;
}.left-0{
  left: 0 !important;
}.right-0{
  right: 0 !important;
}.top-0{
  top: 0 !important;
}.top-32{
  top: 8rem !important;
}.z-10{
  z-index: 10 !important;
}.m-auto{
  margin: auto !important;
}.mx-auto{
  margin-left: auto !important;
  margin-right: auto !important;
}.my-2{
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}.my-4{
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}.my-8{
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}.-mt-2{
  margin-top: -0.5rem !important;
}.mb-0{
  margin-bottom: 0 !important;
}.mb-1{
  margin-bottom: 0.25rem !important;
}.mb-10{
  margin-bottom: 2.5rem !important;
}.mb-2{
  margin-bottom: 0.5rem !important;
}.mb-4{
  margin-bottom: 1rem !important;
}.mb-6{
  margin-bottom: 1.5rem !important;
}.ml-0{
  margin-left: 0 !important;
}.ml-2{
  margin-left: 0.5rem !important;
}.mr-0{
  margin-right: 0 !important;
}.mr-2{
  margin-right: 0.5rem !important;
}.mt-10{
  margin-top: 2.5rem !important;
}.mt-12{
  margin-top: 3rem !important;
}.mt-24{
  margin-top: 6rem !important;
}.mt-6{
  margin-top: 1.5rem !important;
}.mt-8{
  margin-top: 2rem !important;
}.block{
  display: block !important;
}.inline-block{
  display: inline-block !important;
}.inline{
  display: inline !important;
}.flex{
  display: flex !important;
}.table{
  display: table !important;
}.contents{
  display: contents !important;
}.hidden{
  display: none !important;
}.h-full{
  height: 100% !important;
}.w-1\\/2{
  width: 50% !important;
}.w-1\\/3{
  width: 33.33333% !important;
}.w-1\\/4{
  width: 25% !important;
}.w-2\\/3{
  width: 66.66667% !important;
}.w-full{
  width: 100% !important;
}.max-w-2xl{
  max-width: 42rem !important;
}.max-w-3xl{
  max-width: 48rem !important;
}.max-w-md{
  max-width: 28rem !important;
}.max-w-xs{
  max-width: 20rem !important;
}.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}.cursor-pointer{
  cursor: pointer !important;
}.select-none{
  -webkit-user-select: none !important;
          user-select: none !important;
}.flex-col{
  flex-direction: column !important;
}.flex-wrap{
  flex-wrap: wrap !important;
}.items-end{
  align-items: flex-end !important;
}.items-center{
  align-items: center !important;
}.justify-end{
  justify-content: flex-end !important;
}.justify-center{
  justify-content: center !important;
}.justify-between{
  justify-content: space-between !important;
}.overflow-hidden{
  overflow: hidden !important;
}.rounded-lg{
  border-radius: .5rem !important;
}.rounded-none{
  border-radius: 0 !important;
}.border-2{
  border-width: 2px !important;
}.border-b-2{
  border-bottom-width: 2px !important;
}.border-l-2{
  border-left-width: 2px !important;
}.border-none{
  border-style: none !important;
}.border-green{
  --tw-border-opacity: 1 !important;
  border-color: rgb(10 118 58 / var(--tw-border-opacity)) !important;
}.border-green-light{
  --tw-border-opacity: 1 !important;
  border-color: rgb(11 173 127 / var(--tw-border-opacity)) !important;
}.border-grey{
  --tw-border-opacity: 1 !important;
  border-color: rgb(157 166 186 / var(--tw-border-opacity)) !important;
}.border-grey-light{
  --tw-border-opacity: 1 !important;
  border-color: rgb(228 230 235 / var(--tw-border-opacity)) !important;
}.bg-green{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(10 118 58 / var(--tw-bg-opacity)) !important;
}.bg-green-dark{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(15 97 93 / var(--tw-bg-opacity)) !important;
}.bg-green-light{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(11 173 127 / var(--tw-bg-opacity)) !important;
}.bg-grey-figma{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
}.bg-grey-figma-dark{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity)) !important;
}.bg-red{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 72 86 / var(--tw-bg-opacity)) !important;
}.bg-transparent{
  background-color: transparent !important;
}.bg-white{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}.bg-yellow{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 163 0 / var(--tw-bg-opacity)) !important;
}.bg-none{
  background-image: none !important;
}.bg-cover{
  background-size: cover !important;
}.bg-center{
  background-position: center !important;
}.bg-no-repeat{
  background-repeat: no-repeat !important;
}.object-contain{
  object-fit: contain !important;
}.object-cover{
  object-fit: cover !important;
}.object-center{
  object-position: center !important;
}.p-2{
  padding: 0.5rem !important;
}.p-4{
  padding: 1rem !important;
}.p-6{
  padding: 1.5rem !important;
}.px-12{
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}.px-16{
  padding-left: 4rem !important;
  padding-right: 4rem !important;
}.px-2{
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}.px-4{
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}.px-8{
  padding-left: 2rem !important;
  padding-right: 2rem !important;
}.py-1{
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}.py-2{
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}.py-24{
  padding-top: 6rem !important;
  padding-bottom: 6rem !important;
}.py-3{
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}.py-4{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}.pb-6{
  padding-bottom: 1.5rem !important;
}.pl-0{
  padding-left: 0 !important;
}.pl-1{
  padding-left: 0.25rem !important;
}.pl-2{
  padding-left: 0.5rem !important;
}.pl-4{
  padding-left: 1rem !important;
}.pl-5{
  padding-left: 1.25rem !important;
}.pr-1{
  padding-right: 0.25rem !important;
}.pr-12{
  padding-right: 3rem !important;
}.pr-2{
  padding-right: 0.5rem !important;
}.pr-4{
  padding-right: 1rem !important;
}.pt-10{
  padding-top: 2.5rem !important;
}.pt-12{
  padding-top: 3rem !important;
}.pt-2{
  padding-top: 0.5rem !important;
}.pt-20{
  padding-top: 5rem !important;
}.pt-32{
  padding-top: 8rem !important;
}.pt-4{
  padding-top: 1rem !important;
}.pt-8{
  padding-top: 2rem !important;
}.text-left{
  text-align: left !important;
}.text-center{
  text-align: center !important;
}.text-right{
  text-align: right !important;
}.text-2xl{
  font-size: 1.5rem !important;
}.text-3xl{
  font-size: 1.875rem !important;
}.text-base{
  font-size: 1rem !important;
}.text-sm{
  font-size: .9375rem !important;
}.text-xl{
  font-size: 1.25rem !important;
}.text-xs{
  font-size: .75rem !important;
}.font-black{
  font-weight: 900 !important;
}.font-bold{
  font-weight: 700 !important;
}.font-light{
  font-weight: 300 !important;
}.font-semibold{
  font-weight: 600 !important;
}.font-thin{
  font-weight: 200 !important;
}.lowercase{
  text-transform: lowercase !important;
}.leading-none{
  line-height: 1 !important;
}.leading-tight{
  line-height: 1.25 !important;
}.text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(39 39 39 / var(--tw-text-opacity)) !important;
}.text-green{
  --tw-text-opacity: 1 !important;
  color: rgb(10 118 58 / var(--tw-text-opacity)) !important;
}.text-green-dark{
  --tw-text-opacity: 1 !important;
  color: rgb(15 97 93 / var(--tw-text-opacity)) !important;
}.text-green-light{
  --tw-text-opacity: 1 !important;
  color: rgb(11 173 127 / var(--tw-text-opacity)) !important;
}.text-grey{
  --tw-text-opacity: 1 !important;
  color: rgb(157 166 186 / var(--tw-text-opacity)) !important;
}.text-grey-dark{
  --tw-text-opacity: 1 !important;
  color: rgb(80 95 118 / var(--tw-text-opacity)) !important;
}.text-purple{
  --tw-text-opacity: 1 !important;
  color: rgb(81 26 146 / var(--tw-text-opacity)) !important;
}.text-red{
  --tw-text-opacity: 1 !important;
  color: rgb(255 72 86 / var(--tw-text-opacity)) !important;
}.text-red-lighter{
  --tw-text-opacity: 1 !important;
  color: rgb(249 172 170 / var(--tw-text-opacity)) !important;
}.text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}.opacity-0{
  opacity: 0 !important;
}.shadow-lg{
  --tw-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;
  --tw-shadow-colored: 0 15px 30px 0 var(--tw-shadow-color), 0 5px 15px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}.outline{
  outline-style: solid !important;
}.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}html {
  font-family: 'Urbanist', sans-serif;
  /* color: #272727; */
  color: #505f76;
}.button {
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);
  border-radius: .25rem;
  border: 2px solid transparent;
  font-weight: 500;
}.nav-primary .button {
  padding: 1rem .75rem;
}.button:active,.button:focus {
  outline: none
}.button.button-submit {
  background-color: #fc968b;
  color: #fff;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  padding-top: .75rem;
  padding-bottom: .75rem
}.button.button-submit:hover {
  background-color: #f9acaa
}.bg-yellow {
  background-color: #ffa300;
}h1, h2 {
  font-size: 2.5rem;
  line-height: 2.8rem;
  font-weight: 500;
}.text-green {
  color: #007d33;
}.border-red {
  border-color: #ff4856 !important;
}.bg-red-lightblank {
  background-color: #ffe4e6;
}.anchor-in-menu a {
  display: block;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);
  font-weight: 600;
  font-size: .9375rem;
  padding: 1rem 0.75rem;
  border-radius: 0.25rem;
  border: 2px solid transparent;
}.anchor-in-menu.button-red a {
  background-color: #ff4856;
}.anchor-in-menu.button-yellow a {
  background-color: #ffa300;
}@media screen and (min-width: 992px) {
  .anchor-in-menu a {
    display: inline-block;
  }
}.get-scale {
  transform: scale(1);
  transition: 0.2s;
}.get-scale:hover {
    filter: opacity(0.5);
    transform: scale(var(--scale));
  }/* inViewport */[data-inviewport="scale-in"] {
  transition: 1s;
  transform: scale(0.1);
}[data-inviewport="scale-in"].is-inViewport {
  transform: scale(1);
}[data-inviewport="right-in"] {
  transition: 1s;
  transform: translate(30%, 0);
}[data-inviewport="right-in"].is-inViewport {
  transform: translate(0, 0);
}[data-inviewport="crawl-in"] {
  transition: 1s;
  transform: translate(0, 30%);
}[data-inviewport="crawl-in"].is-inViewport {
  transform: translate(0, 0);
}[data-inviewport="fade-in"] {
  transition: 1s;
  opacity: 0;
}[data-inviewport="fade-in"].is-inViewport {
  opacity: 1;
}[data-inviewport="bg-in"] {
  transition: 1s;
  background-size: 130% 130%;
}[data-inviewport="bg-in"].is-inViewport {
  background-size: 100% 100%;
}.bg-alt-resource a {
  font-size: 1rem !important;
  background: none;
  border: 2px solid white;
  box-shadow: none;
}.bg-alt-resource a:hover {
  transition: 0.2s;
  background: white;
  color: #0f615d;
}.bg-green-light {
  background-color: #0bad7f;
}.hamburger {
  cursor: pointer;
  transform: rotate(0);
  transition: 0.5s ease-in-out;
  width: 24px;
  height: 28px;
  z-index: 3;
}.hamburger div {
    background: #272727;
    border-radius: 9px;
    display: block;
    height: 1px;
    left: -10px;
    position: absolute;
    transform: rotate(0);
    transition: 0.25s ease-in-out;
    width: calc(100% + 5px);
  }.hamburger div:nth-child(1) {
      top: 9px;
    }.hamburger div:nth-child(2),
    .hamburger div:nth-child(3) {
      top: 18px;
    }.hamburger div:nth-child(4) {
      top: 27px;
    }.hamburger.open {
    z-index: 10;
    transform: scale(0.7) translate(-12px, -2px);
  }.hamburger.open div:nth-child(1),
      .hamburger.open div:nth-child(4) {
        left: 50%;
        top: 18px;
        width: 0%;
      }.hamburger.open div:nth-child(2) {
        transform: rotate(45deg);
      }.hamburger.open div:nth-child(3) {
        transform: rotate(-45deg);
      }.accordion-content ul {
    list-style: disc;
    margin-left: 18px;
  }.accordion-content ol {
    list-style: auto;
    margin-left: 18px;
  }.accordion-content ul {
		list-style: disc;
		margin-left: 18px;
	}.accordion-content ol {
		list-style: decimal;
		margin-left: 18px;
	}.anchor-in-menu.button-green-light a {
  background-color: #38b981;
}.anchor-in-menu ul.sub-menu {
    pointer-events: none;
		position: absolute;
		max-width: 100%;
		border: 2px solid #ff4856;
		background-color: white;
		border-top: none;
		transform: translate(0px, -58px);
		z-index: -1;
		opacity: 0;
		transition: 0.2s;
	}.anchor-in-menu ul.sub-menu li a:hover {
					color: white;
				}.anchor-in-menu ul.sub-menu li a:hover:before {
						width: 100%;
					}.anchor-in-menu ul.sub-menu li a:before {
					content: '';
					position: absolute;
					z-index: -1;
					width: 0;
					height: 100%;
					background: #ff4856;
					top: 0;
					left: 0;
					transition: 0.2s;
				}.anchor-in-menu ul.sub-menu li a{
				background: none;
				border: 0;
				box-shadow: none;
				color: black;
				width: 100%;
				position: relative;
				padding: 1rem 1.75rem;
}.anchor-in-menu:hover ul.sub-menu {
      pointer-events: all;
			transform: translate(0px, 0px);
			opacity: 1;
			border-radius: 0px 0px 14px 14px;
			overflow: hidden;
			border-top: 0 !important;
			position: relative;
			z-index: 99999;
		}.anchor-in-menu.button-red ul.sub-menu {
		border: 2px solid #ff4856;
	}.anchor-in-menu.button-red ul.sub-menu li a:before {
					background: #ff4856;
				}.anchor-in-menu.button-red ul.sub-menu li:not(:last-child) {
				border-bottom: 2px solid #fed2d6;
			}.anchor-in-menu.button-yellow ul.sub-menu {
		border: 2px solid #ffa300;
	}.anchor-in-menu.button-yellow ul.sub-menu li a:before {
					background: #ffa300;
				}.anchor-in-menu.button-yellow ul.sub-menu li:not(:last-child) {
				border-bottom: 2px solid #ffe5b9;
			}.anchor-in-menu.menu-item-has-children >a:after {
			content: "";
			margin-left: 15px;
			display: inline-block;
			border-left: 2px solid #fff;
			border-bottom: 2px solid #fff;
			width: 10px;
			height: 10px;
			transform: rotate(-45deg);
			transition: 0.2s;
			float: right;
		}.anchor-in-menu.menu-item-has-children:hover >a:after {
				transform: rotate(135deg);
			}.anchor-in-menu.menu-item-has-children.first-anchor >a {
		pointer-events: none;
	}.mdhidden {
  display: block;
}@media screen and (min-width: 992px) {
		.anchor-in-menu.menu-item-has-children >a {
			pointer-events: all !important;
		}
			.anchor-in-menu.menu-item-has-children >a:after {
				float: none;
			}
			.anchor-in-menu:hover ul.sub-menu {
				position: absolute;
				z-index: 1;
			}
  .mdhidden {
    display: none;
  }
}.single-chart {
  justify-content: space-around;
}.circular-chart {
  display: block;
  margin: 10px auto;
  max-width: 50%;
  max-height: 250px;
}.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}.circle {
  fill: none;
  stroke-width: 3.8;
  stroke-linecap: round;
  animation: progress 1s ease-out forwards;
}@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}.circular-chart .circle {
  stroke: #80d080;
}.percentage {
  fill: white;
  font-size: 0.5em;
  text-anchor: middle;
  font-weight: bold;
}.semi-circle-wrap::before,
.semi-circle-wrap::after {
  content: '';
  height: 100px;
  width: 100%;
  background-color: #0f615d;
  display: block;
}.semi-circle-wrap--grey::before,
  .semi-circle-wrap--grey::after {
    content: '';
    background-color: #f2f2f2;
  }.semi-circle-wrap::before {
  border-radius: 100% 100% 0 0;
}.semi-circle-wrap::after {
  border-radius: 0 0 100% 100%;
}.semi-circle-wrap--smalltop::before {
    height: 60px;
    margin-bottom: -25px;
  }.semi-circle-wrap--smallbottom::after {
    height: 60px;
  }.semi-circle-wrap--nobottom::after {
    border-radius: 0;
  }.semi-circle-wrap--notop::before {
    border-radius: 0;
  }.semi-circle-wrap.bg-transparent::before,
  .semi-circle-wrap.bg-transparent::after {
    background-color: transparent;
  }.semi-circle-wrap.bg-transparent .bg-green-dark {
    background-color: transparent;
  }.semi-circle-wrap.bg-transparent .text-white {
    color: #0f615d !important;
  }.semi-circle-wrap.bg-transparent .percentage {
    fill: #0f615d;
  }.snazzy-list_wrapper {
  width: 500px;
  max-width: 100%;
  margin: auto;
}.snazzy-list {
  counter-increment: section;
  position: relative;
}.snazzy-list::before{
  --tw-text-opacity: 1;
  color: rgb(10 118 58 / var(--tw-text-opacity));
  color: #007d33;

    content: counter(section);
    right: 100%;
    margin-right: 1px;
    margin-top: 0;
    border-radius: 50%;
    padding: 10px;
    height: 100px;
    width: 100px;
    text-align: left;
    font-size: 3rem;
    font-weight: 900;
    opacity: 1;
}@media (min-width: 992px) {
  .snazzy-list {
    margin-bottom: 58px;
  }

    .snazzy-list::before {
      margin-top: -110px;
      text-align: center;
      position: absolute;
      font-size: 10rem;
    }
}.snazzy-list:nth-child(2)::before,
.snazzy-list:nth-child(5n)::before{
  --tw-text-opacity: 1;
  color: rgb(255 72 86 / var(--tw-text-opacity));
}.snazzy-list:nth-child(3)::before,
.snazzy-list:nth-child(6n)::before{
  --tw-text-opacity: 1;
  color: rgb(255 163 0 / var(--tw-text-opacity));
}.tronc-compare-wrapper input[type=range] {
  -webkit-appearance: none;
  margin: 18px 0;
  width: 100%;
  z-index: 2;
  position: relative;
  }.tronc-compare-wrapper input[type=range]:focus {
  outline: none;
  }.tronc-compare-wrapper input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 12px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;
  background: transparent;
  border-radius: 5px;
  border: 0.2px solid #fff;
  }.tronc-compare-wrapper input[type=range]::-webkit-slider-thumb {
  height: 25px;
  width: 25px;
  border-radius: 100%;
  background: #0bad7f;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -8px;
  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 2px #fff;
  position: relative;
  z-index: 3;
  }.tronc-compare-wrapper input[type=range]::-moz-range-track {
  width: 100%;
  height: 12px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;
  background: transparent;
  border-radius: 5px;
  border: 0.2px solid #fff;
  }.tronc-compare-wrapper input[type=range]::-moz-range-thumb {
  height: 25px;
  width: 25px;
  border-radius: 100%;
  background: #0bad7f;
  cursor: pointer;
  border: 2px solid white;
  position: relative;
  z-index: 3;
  }.tronc-compare-wrapper input[type=range]::-ms-track {
  width: 100%;
  height: 12px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
  }.tronc-compare-wrapper input[type=range]::-ms-fill-lower {
  background: #0bad7f;
  border: 0.2px solid #fff;
  border-radius: 2.6px;
  }.tronc-compare-wrapper input[type=range]::-ms-fill-upper {
  background: #0a763a;
  border: 0.2px solid #fff;
  border-radius: 2.6px;
  border: 2px solid white;
  }.tronc-compare-wrapper input[type=range]::-ms-thumb {
  height: 25px;
  width: 25px;
  border-radius: 100%;
  background: #0bad7f;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;
  position: relative;
  z-index: 3;
  }.tronc-compare-wrapper input[type=range]:focus::-ms-fill-lower {
  background: #0bad7f;
  }.tronc-compare-wrapper input[type=range]:focus::-ms-fill-upper {
  background: #0bad7f;
  }.range-bg {
  width: 100%;
  height: 12px;
  background: #fafafa;
  position: absolute;
  z-index: 1;
  border-radius: 5px;
  border: 1px solid #ececec
  }.tronc-compare-wrapper input[type=range]:active::-webkit-slider-runnable-track, input[type=range]:focus::-webkit-slider-runnable-track,
  .tronc-compare-wrapper input[type=range]:active::-moz-range-thumb, input[type=range]:focus::-moz-range-thumb,
  .tronc-compare-wrapper input[type=range]:active::-ms-thumb, input[type=range]:focus::-ms-thumb,
  .tronc-compare-wrapper input[type=range]:active::-ms-track, input[type=range]:focus::-ms-track,
  .tronc-compare-wrapper input[type=range]:active::-moz-range-track, input[type=range]:focus::-moz-range-track,
  .tronc-compare-wrapper input[type=range]:active::-webkit-slider-thumb, input[type=range]:focus::-webkit-slider-thumb {
  cursor: grabbing;
  }.tronc-compare .maximage {
  max-height: 65px;
  }.tronc-compare #comparison-table .head {
  padding-left: 0;
  padding-right: 0;
  }.userInput:hover svg {
  display: inline-block;
  }.userInput svg {
  display: hidden;
  background-color: white;
  }@media screen and (max-width: 992px) {
  .tronc-compare .accordion .accordion-trigger.reverse {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
  }
  .bg-gone {
  background: none !important;
  }
  .outline-tronc {
  height: 75%;
  }
  .employee-heading {
  top: -14px;
  position: absolute;
  }
  .alterative-em {
  position: absolute;
  z-index: 21;
  }
  .tronc-compare #comparison-table .head.main-stick {
  top: 88px;
  }
  .tronc-compare #comparison-table .head.main-stick.top-32 {
  top: 51px;
  }
  .first-bracket p {
  padding-bottom: 25px;
  }

  .wp-block-tronculator {
    max-width: 95%;
    margin: 0 auto;
    }
  }@media screen and (min-width: 992px) {
  .tronc-compare #comparison-table .head.main-stick {
  top: 103px;
  z-index: 21;
  background: none;
  }
  
  .tronc-compare #comparison-table .head.main-stick.top-32 {
  top: 55px;
  }
  
  .tronc-compare .main-stick:before {
  content: '';
  
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  }
  .tronc-compare #comparison-table .head {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  }
  .transform-small {
  transform: translate(5px, 0px);
  }
  }@media screen and (min-width: 1200px) {
  .tronc-compare .main-stick:before {
  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) 33.33333%, rgb(250 250 250) 33.33333% , rgb(250 250 250) 50%, rgb(250 250 250) 50%, rgb(250 250 250) 66.66667%,rgba(11,173,127,1) 66.66667%, rgba(11,173,127,1) 83.44334%,rgba(250,250,250,1) 83.44334%);  */
  }
  }@media screen and (min-width: 992px) and (max-width: 1199px) {
  .tronc-compare .main-stick:before {
  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) calc(100% - 634.5px), rgb(250 250 250) calc(100% - 634.5px), rgb(250 250 250) calc(100% - 316.5px),rgba(11,173,127,1) calc(100% - 316.5px), rgba(11,173,127,1) calc(100% - 156.5px),rgba(250,250,250,1) calc(100% - 156.5px)); */
  /* background: linear-gradient(90deg, rgb(255 255 255) 0vw, rgb(255 255 255) calc(100vw - 715.5px), rgb(250 250 250) calc(100vw - 715.5px), rgb(250 250 250) calc(100vw - 398.5px),rgba(11,173,127,1) calc(100vw - 398.5px), rgba(11,173,127,1) calc(100vw - 237.5px),rgba(250,250,250,1) calc(100vw - 237.5px)); */
  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) 33.33333%, rgb(250 250 250) 33.33333% , rgb(250 250 250) 50%, rgb(250 250 250) 50%, rgb(250 250 250) 66.66667%,rgba(11,173,127,1) 66.66667%, rgba(11,173,127,1) 83.44334%,rgba(250,250,250,1) 83.44334%);  */
  }
  }.accordion {
  transition: background 0.6s ease;
}.accordion .accordion-trigger:not(.no-action)::before,
      .accordion .accordion-trigger:not(.no-action)::after {
        content: "";
        width: 14px;
        height: 2px;
        position: absolute;
        right: 10px;
        top: 16px;
        transform: translate3d(0, -50%, 0);
        transition: transform 0.2s ease;
        backface-visibility: hidden;
        z-index: 2;
        --tw-bg-opacity: 1;
        background-color: rgb(39 39 39 / var(--tw-bg-opacity));
      }.accordion .accordion-trigger:not(.no-action)::after {
        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 90deg);
      }.accordion .accordion-trigger h2.reset-styles {
      font-family: \$gilroy;

      @include fontFixPixel;

      margin-bottom: 0;

      margin-top: 0;

      font-weight: 700;

      line-height: 1.5;
    }.accordion .accordion-trigger.reverse{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 3rem;
  padding-right: 1.25rem;
  line-height: 1.25;
}.accordion .accordion-trigger.reverse::before,
      .accordion .accordion-trigger.reverse::after {
        right: initial;
        left: 1.5rem;
        --tw-bg-opacity: 1;
        background-color: rgb(157 166 186 / var(--tw-bg-opacity));
      }.accordion .accordion-trigger.reverse.no-action{
  padding-left: 1rem;
}@media (min-width: 992px) {.accordion .accordion-trigger.reverse.no-action{
    padding-left: 1.5rem;
  }
        }.accordion .accordion-image {
    display: none;
    right: 10%;
  }.accordion .accordion-image.reverse {
      left: 10%;
      right: initial;
    }.accordion .accordion-content a:not(.link){
  --tw-text-opacity: 1;
  color: rgb(10 118 58 / var(--tw-text-opacity));
  text-decoration-line: underline;
  color: #007d33;
}.accordion .accordion-content a:not(.link):hover{
  text-decoration-line: none;
}.accordion.open{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}.accordion.open .accordion-trigger::before {
        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 0deg);
      }.accordion.open .accordion-trigger::after {
        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 0deg);
      }@media (min-width: 992px) {
      .accordion.open .accordion-image {
        display: block;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        animation: fadeIn 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
      }
    }.accordion.open .chev-on .feather-chevron-down {
        display: none !important;
      }.accordion.open .chev-on .feather-chevron-up {
        display: inline-block !important;
      }.tronc-compare-wrapper {
  border: 0 solid #e4e6eb;
}#comparison-table .head {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    top: 85px;
    z-index: 1;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  }@media (min-width: 576px) {#comparison-table .head {
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      top: 124px
  }
    }@media (min-width: 992px) {#comparison-table .head {
      top: 94px
  }
    }#comparison-table .head .phorest-logo {
      max-height: 60px;
    }@media (min-width: 992px) {#comparison-table.competitor-var .head {
        top: 110px
    }
      }#comparison-table .accordion-trigger {
    /* stylelint-enable */
  }/* stylelint-disable no-descending-specificity */#comparison-table .accordion-trigger p,
    #comparison-table .accordion-trigger h3 {
      margin-bottom: 0;
      margin-left: 20px;
    }#comparison-table .accordion.open .accordion-trigger.reverse::before,
          #comparison-table .accordion.open .accordion-trigger.reverse::after{
  --tw-bg-opacity: 1;
  background-color: rgb(10 118 58 / var(--tw-bg-opacity));
}#comparison-table .accordion.open .accordion-trigger.reverse .text-grey{
  --tw-text-opacity: 1;
  color: rgb(10 118 58 / var(--tw-text-opacity));
  color: #007d33;
}#comparison-table .accordion .accordion-trigger::before,
      #comparison-table .accordion .accordion-trigger::after,
      #comparison-table .accordion:not(.no-action)::before,
      #comparison-table .accordion:not(.no-action)::after {
        top: 37px;
        left: 0;
      }#comparison-table .accordion-content{
  padding: 0;
}#comparison-table .accordion-content > div {
      border-bottom: 1px;
      border-style: solid;
      --tw-border-opacity: 1;
      border-color: rgb(228 230 235 / var(--tw-border-opacity));
    }#comparison-table .accordion-content > div:last-child {
        border: none;
      }#comparison-table .accordion-content > div svg {
        margin: auto;
        width: 21px;
        height: 21px;
        color: #fff;
        padding: 4px;
        stroke-width: 2px;
        border-radius: 100%;
        --tw-bg-opacity: 1;
        background-color: rgb(15 97 93 / var(--tw-bg-opacity));

      }.semi-circle-wrap.bg-transparent #comparison-table .accordion-content > div svg {
    background-color: transparent;
  }#comparison-table .accordion-content > div p {
        /* stylelint-disable-line no-descending-specificity */
        font-size: 13px;
        margin-bottom: 0;
        font-weight: 400;
        line-height: 1.25;
      }@media (min-width: 576px) {#comparison-table .accordion-content > div p {
          font-size: 15px
      }
        }#comparison-table.compare-vs {
    background: linear-gradient(270deg, #fff 50%, transparent 0%);
  }@media (min-width: 992px) {#comparison-table.compare-vs {
      top: 90px
  }
    }#comparison-table.compare-vs::before {
      content: '';
      height: calc(84% - 19px);
      width: 19%;
      left: 50%;
      border: 2px solid #80d080;
      position: absolute;
      top: 15%;
      z-index: 2;
      border-radius: 5px;
    }@media (min-width: 768px) {#comparison-table.compare-vs::before {
        width: 24%;
        height: calc(90% - 5px);
        top: 10%
    }
      }@media (min-width: 992px){.lg\\:container{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }@media (min-width: 576px){.lg\\:container{
      max-width: 576px;
    }
  }@media (min-width: 768px){.lg\\:container{
      max-width: 768px;
    }
  }@media (min-width: 992px){.lg\\:container{
      max-width: 992px;
    }
  }@media (min-width: 1200px){.lg\\:container{
      max-width: 1200px;
    }
  }
}.hover\\:bg-red-light:hover{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(252 150 139 / var(--tw-bg-opacity)) !important;
}.hover\\:shadow-none:hover{
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}.focus\\:not-sr-only:focus{
  position: static !important;
  width: auto !important;
  height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: normal !important;
}.group:hover .group-hover\\:inline-block{
  display: inline-block !important;
}.group:focus .group-focus\\:hidden{
  display: none !important;
}@media (min-width: 576px){.sm\\:mb-0{
    margin-bottom: 0 !important;
  }.sm\\:mr-4{
    margin-right: 1rem !important;
  }.sm\\:mr-5{
    margin-right: 1.25rem !important;
  }.sm\\:px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }.sm\\:text-4xl{
    font-size: 2.25rem !important;
  }
}@media (min-width: 768px){.md\\:ml-auto{
    margin-left: auto !important;
  }.md\\:mt-0{
    margin-top: 0 !important;
  }.md\\:w-1\\/3{
    width: 33.33333% !important;
  }.md\\:w-1\\/4{
    width: 25% !important;
  }.md\\:w-3\\/4{
    width: 75% !important;
  }.md\\:flex-none{
    flex: none !important;
  }.md\\:bg-transparent{
    background-color: transparent !important;
  }.md\\:p-4{
    padding: 1rem !important;
  }.md\\:py-12{
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }.md\\:pl-4{
    padding-left: 1rem !important;
  }.md\\:pt-0{
    padding-top: 0 !important;
  }.md\\:text-right{
    text-align: right !important;
  }.md\\:text-lg{
    font-size: 1.125rem !important;
  }
}@media (min-width: 992px){.lg\\:static{
    position: static !important;
  }.lg\\:z-10{
    z-index: 10 !important;
  }.lg\\:z-20{
    z-index: 20 !important;
  }.lg\\:mb-10{
    margin-bottom: 2.5rem !important;
  }.lg\\:mb-2{
    margin-bottom: 0.5rem !important;
  }.lg\\:mr-5{
    margin-right: 1.25rem !important;
  }.lg\\:mt-0{
    margin-top: 0 !important;
  }.lg\\:block{
    display: block !important;
  }.lg\\:inline-block{
    display: inline-block !important;
  }.lg\\:flex{
    display: flex !important;
  }.lg\\:hidden{
    display: none !important;
  }.lg\\:w-1\\/2{
    width: 50% !important;
  }.lg\\:w-1\\/4{
    width: 25% !important;
  }.lg\\:w-1\\/5{
    width: 20% !important;
  }.lg\\:w-1\\/6{
    width: 16.66667% !important;
  }.lg\\:w-2\\/5{
    width: 40% !important;
  }.lg\\:w-2\\/6{
    width: 33.33333% !important;
  }.lg\\:w-auto{
    width: auto !important;
  }.lg\\:max-w-full{
    max-width: 100% !important;
  }.lg\\:border-none{
    border-style: none !important;
  }.lg\\:bg-grey-figma{
    --tw-bg-opacity: 1 !important;
    background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;
  }.lg\\:bg-transparent{
    background-color: transparent !important;
  }.lg\\:pb-0{
    padding-bottom: 0 !important;
  }.lg\\:pb-4{
    padding-bottom: 1rem !important;
  }.lg\\:pl-12{
    padding-left: 3rem !important;
  }.lg\\:pr-4{
    padding-right: 1rem !important;
  }.lg\\:pt-0{
    padding-top: 0 !important;
  }.lg\\:pt-4{
    padding-top: 1rem !important;
  }.lg\\:text-4xl{
    font-size: 2.25rem !important;
  }.lg\\:text-base{
    font-size: 1rem !important;
  }.lg\\:text-xl{
    font-size: 1.25rem !important;
  }.lg\\:font-semibold{
    font-weight: 600 !important;
  }
}

`, "",{"version":3,"sources":["webpack://./styles/app.css"],"names":[],"mappings":";;;AAG2G;;CAE1G,CAAC;;;CAGD,CAAC;;;EAGA,sBAAsB,EAAE,MAAM;EAC9B,eAAe,EAAE,MAAM;EACvB,mBAAmB,EAAE,MAAM;EAC3B,0BAA0B,EAAE,MAAM;AACpC,CAAC;;EAEC,gBAAgB;AAClB,CAAC;;;;;;;CAOA,CAAC;EACA,gBAAgB,EAAE,MAAM;EACxB,8BAA8B,EAAE,MAAM;EACtC,gBAAgB,EAAE,MAAM;EACxB,WAAW,EAAE,MAAM;EACnB,4NAA4N,EAAE,MAAM;EACpO,6BAA6B,EAAE,MAAM;EACrC,+BAA+B,EAAE,MAAM;AACzC,CAAC;;;CAGA,CAAC;EACA,SAAS,EAAE,MAAM;EACjB,oBAAoB,EAAE,MAAM;AAC9B,CAAC;;;;CAIA,CAAC;EACA,SAAS,EAAE,MAAM;EACjB,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;AAC/B,CAAC;;CAEA,CAAC;EACA,0BAA0B;EAC1B,yCAAyC;UACjC,iCAAiC;AAC3C,CAAC;;CAEA,CAAC;;;;;;EAMA,kBAAkB;EAClB,oBAAoB;AACtB,CAAC;;CAEA,CAAC;EACA,cAAc;EACd,wBAAwB;AAC1B,CAAC;;CAEA,CAAC;;EAEA,mBAAmB;AACrB,CAAC;;;CAGA,CAAC;;;;EAIA,+GAA+G,EAAE,MAAM;EACvH,cAAc,EAAE,MAAM;AACxB,CAAC;;CAEA,CAAC;EACA,cAAc;AAChB,CAAC;;CAEA,CAAC;;EAEA,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B,CAAC;EACC,eAAe;AACjB,CAAC;EACC,WAAW;AACb,CAAC;;;;CAIA,CAAC;EACA,cAAc,EAAE,MAAM;EACtB,qBAAqB,EAAE,MAAM;EAC7B,yBAAyB,EAAE,MAAM;AACnC,CAAC;;;;CAIA,CAAC;;;;;EAKA,oBAAoB,EAAE,MAAM;EAC5B,8BAA8B,EAAE,MAAM;EACtC,gCAAgC,EAAE,MAAM;EACxC,eAAe,EAAE,MAAM;EACvB,oBAAoB,EAAE,MAAM;EAC5B,oBAAoB,EAAE,MAAM;EAC5B,cAAc,EAAE,MAAM;EACtB,SAAS,EAAE,MAAM;EACjB,UAAU,EAAE,MAAM;AACpB,CAAC;;CAEA,CAAC;;EAEA,oBAAoB;AACtB,CAAC;;;CAGA,CAAC;;;;EAIA,0BAA0B,EAAE,MAAM;EAClC,6BAA6B,EAAE,MAAM;EACrC,sBAAsB,EAAE,MAAM;AAChC,CAAC;;CAEA,CAAC;EACA,aAAa;AACf,CAAC;;CAEA,CAAC;EACA,gBAAgB;AAClB,CAAC;;CAEA,CAAC;EACA,wBAAwB;AAC1B,CAAC;;CAEA,CAAC;;EAEA,YAAY;AACd,CAAC;;;CAGA,CAAC;EACA,6BAA6B,EAAE,MAAM;EACrC,oBAAoB,EAAE,MAAM;AAC9B,CAAC;;CAEA,CAAC;EACA,wBAAwB;AAC1B,CAAC;;;CAGA,CAAC;EACA,0BAA0B,EAAE,MAAM;EAClC,aAAa,EAAE,MAAM;AACvB,CAAC;;CAEA,CAAC;EACA,kBAAkB;AACpB,CAAC;;CAEA,CAAC;;;;;;;;;;;;;EAaA,SAAS;AACX,CAAC;EACC,SAAS;EACT,UAAU;AACZ,CAAC;EACC,UAAU;AACZ,CAAC;;;EAGC,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ,CAAC;;CAEA,CAAC;EACA,UAAU;AACZ,CAAC;;CAEA,CAAC;EACA,gBAAgB;AAClB,CAAC;;;CAGA,CAAC;;EAEA,UAAU,EAAE,MAAM;EAClB,cAAc,EAAE,MAAM;AACxB,CAAC;;CAEA,CAAC;;EAEA,eAAe;AACjB,CAAC;;CAEA,CAAC;EACA,eAAe;AACjB,CAAC;;;;CAIA,CAAC;;;;;;;;EAQA,cAAc,EAAE,MAAM;EACtB,sBAAsB,EAAE,MAAM;AAChC,CAAC;;CAEA,CAAC;;EAEA,eAAe;EACf,YAAY;AACd,CAAC,wEAAwE,CAAC;EACxE,aAAa;AACf,CAAC;EACC,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB,CAAC;EACC,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB,CAAC;EACC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB,CAAC,0BAA0B;IACvB,gBAAgB;EAClB;AACF,CAAC,0BAA0B;IACvB,gBAAgB;EAClB;AACF,CAAC,0BAA0B;IACvB,gBAAgB;EAClB;AACF,CAAC,2BAA2B;IACxB,iBAAiB;EACnB;AACF,CAAC;EACC,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;AAC5B,CAAC;EACC,+BAA+B;AACjC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,oBAAoB;AACtB,CAAC;EACC,kBAAkB;AACpB,CAAC;EACC,mBAAmB;AACrB,CAAC;EACC,iBAAiB;AACnB,CAAC;EACC,oBAAoB;AACtB,CAAC;EACC,sBAAsB;AACxB,CAAC;EACC,uBAAuB;AACzB,CAAC;EACC,4BAA4B;EAC5B,6BAA6B;AAC/B,CAAC;EACC,6BAA6B;EAC7B,gCAAgC;AAClC,CAAC;EACC,2BAA2B;EAC3B,8BAA8B;AAChC,CAAC;EACC,2BAA2B;EAC3B,8BAA8B;AAChC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,+BAA+B;AACjC,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,wBAAwB;AAC1B,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,wBAAwB;AAC1B,CAAC;EACC,uBAAuB;AACzB,CAAC;EACC,qBAAqB;AACvB,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,qBAAqB;AACvB,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,sBAAsB;AACxB,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,0MAA0M;AAC5M,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,oCAAoC;UAC5B,4BAA4B;AACtC,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,oCAAoC;AACtC,CAAC;EACC,kCAAkC;AACpC,CAAC;EACC,yCAAyC;AAC3C,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,+BAA+B;AACjC,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,mCAAmC;AACrC,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,iCAAiC;EACjC,kEAAkE;AACpE,CAAC;EACC,iCAAiC;EACjC,mEAAmE;AACrE,CAAC;EACC,iCAAiC;EACjC,oEAAoE;AACtE,CAAC;EACC,iCAAiC;EACjC,oEAAoE;AACtE,CAAC;EACC,6BAA6B;EAC7B,kEAAkE;AACpE,CAAC;EACC,6BAA6B;EAC7B,iEAAiE;AACnE,CAAC;EACC,6BAA6B;EAC7B,mEAAmE;AACrE,CAAC;EACC,6BAA6B;EAC7B,oEAAoE;AACtE,CAAC;EACC,6BAA6B;EAC7B,oEAAoE;AACtE,CAAC;EACC,6BAA6B;EAC7B,kEAAkE;AACpE,CAAC;EACC,wCAAwC;AAC1C,CAAC;EACC,6BAA6B;EAC7B,oEAAoE;AACtE,CAAC;EACC,6BAA6B;EAC7B,kEAAkE;AACpE,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,sCAAsC;AACxC,CAAC;EACC,uCAAuC;AACzC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,kCAAkC;AACpC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,wBAAwB;AAC1B,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,6BAA6B;EAC7B,8BAA8B;AAChC,CAAC;EACC,6BAA6B;EAC7B,8BAA8B;AAChC,CAAC;EACC,+BAA+B;EAC/B,gCAAgC;AAClC,CAAC;EACC,6BAA6B;EAC7B,8BAA8B;AAChC,CAAC;EACC,6BAA6B;EAC7B,8BAA8B;AAChC,CAAC;EACC,+BAA+B;EAC/B,kCAAkC;AACpC,CAAC;EACC,8BAA8B;EAC9B,iCAAiC;AACnC,CAAC;EACC,4BAA4B;EAC5B,+BAA+B;AACjC,CAAC;EACC,+BAA+B;EAC/B,kCAAkC;AACpC,CAAC;EACC,4BAA4B;EAC5B,+BAA+B;AACjC,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,+BAA+B;AACjC,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,iCAAiC;AACnC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,8BAA8B;AAChC,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,2BAA2B;AAC7B,CAAC;EACC,oCAAoC;AACtC,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,4BAA4B;AAC9B,CAAC;EACC,+BAA+B;EAC/B,wDAAwD;AAC1D,CAAC;EACC,+BAA+B;EAC/B,yDAAyD;AAC3D,CAAC;EACC,+BAA+B;EAC/B,wDAAwD;AAC1D,CAAC;EACC,+BAA+B;EAC/B,0DAA0D;AAC5D,CAAC;EACC,+BAA+B;EAC/B,2DAA2D;AAC7D,CAAC;EACC,+BAA+B;EAC/B,yDAAyD;AAC3D,CAAC;EACC,+BAA+B;EAC/B,yDAAyD;AAC3D,CAAC;EACC,+BAA+B;EAC/B,yDAAyD;AAC3D,CAAC;EACC,+BAA+B;EAC/B,2DAA2D;AAC7D,CAAC;EACC,+BAA+B;EAC/B,2DAA2D;AAC7D,CAAC;EACC,qBAAqB;AACvB,CAAC;EACC,qFAAqF;EACrF,yGAAyG;EACzG,kHAAkH;AACpH,CAAC;EACC,+BAA+B;AACjC,CAAC;EACC,2KAA2K;EAC3K,mKAAmK;EACnK,4LAA4L;EAC5L,mEAAmE;EACnE,qCAAqC;AACvC,CAAC;EACC,mCAAmC;EACnC,oBAAoB;EACpB,cAAc;AAChB,CAAC;EACC,sCAAsC;EACtC,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB,CAAC;EACC,oBAAoB;AACtB,CAAC;EACC;AACF,CAAC;EACC,yBAAyB;EACzB,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB;AACF,CAAC;EACC;AACF,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB,CAAC;EACC,cAAc;AAChB,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;AAC/B,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC;IACE,qBAAqB;EACvB;AACF,CAAC;EACC,mBAAmB;EACnB,gBAAgB;AAClB,CAAC;IACG,oBAAoB;IACpB,8BAA8B;EAChC,CAAC,eAAe,CAAC;EACjB,cAAc;EACd,qBAAqB;AACvB,CAAC;EACC,mBAAmB;AACrB,CAAC;EACC,cAAc;EACd,4BAA4B;AAC9B,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,cAAc;EACd,4BAA4B;AAC9B,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,cAAc;EACd,UAAU;AACZ,CAAC;EACC,UAAU;AACZ,CAAC;EACC,cAAc;EACd,0BAA0B;AAC5B,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB,CAAC;EACC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB,CAAC;EACC,yBAAyB;AAC3B,CAAC;EACC,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,UAAU;AACZ,CAAC;IACG,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;IAC7B,uBAAuB;EACzB,CAAC;MACG,QAAQ;IACV,CAAC;;MAEC,SAAS;IACX,CAAC;MACC,SAAS;IACX,CAAC;IACD,WAAW;IACX,4CAA4C;EAC9C,CAAC;;QAEK,SAAS;QACT,SAAS;QACT,SAAS;MACX,CAAC;QACC,wBAAwB;MAC1B,CAAC;QACC,yBAAyB;MAC3B,CAAC;IACH,gBAAgB;IAChB,iBAAiB;EACnB,CAAC;IACC,gBAAgB;IAChB,iBAAiB;EACnB,CAAC;EACD,gBAAgB;EAChB,iBAAiB;CAClB,CAAC;EACA,mBAAmB;EACnB,iBAAiB;CAClB,CAAC;EACA,yBAAyB;AAC3B,CAAC;IACG,oBAAoB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,gBAAgB;CACjB,CAAC;KACG,YAAY;IACb,CAAC;MACC,WAAW;KACZ,CAAC;KACD,WAAW;KACX,kBAAkB;KAClB,WAAW;KACX,QAAQ;KACR,YAAY;KACZ,mBAAmB;KACnB,MAAM;KACN,OAAO;KACP,gBAAgB;IACjB,CAAC;IACD,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB,CAAC;MACK,mBAAmB;GACtB,8BAA8B;GAC9B,UAAU;GACV,gCAAgC;GAChC,gBAAgB;GAChB,wBAAwB;GACxB,kBAAkB;GAClB,cAAc;EACf,CAAC;EACD,yBAAyB;CAC1B,CAAC;KACG,mBAAmB;IACpB,CAAC;IACD,gCAAgC;GACjC,CAAC;EACF,yBAAyB;CAC1B,CAAC;KACG,mBAAmB;IACpB,CAAC;IACD,gCAAgC;GACjC,CAAC;GACD,WAAW;GACX,iBAAiB;GACjB,qBAAqB;GACrB,2BAA2B;GAC3B,6BAA6B;GAC7B,WAAW;GACX,YAAY;GACZ,yBAAyB;GACzB,gBAAgB;GAChB,YAAY;EACb,CAAC;IACC,yBAAyB;GAC1B,CAAC;EACF,oBAAoB;CACrB,CAAC;EACA,cAAc;AAChB,CAAC;EACC;GACC,8BAA8B;EAC/B;GACC;IACC,WAAW;GACZ;GACA;IACC,kBAAkB;IAClB,UAAU;GACX;EACD;IACE,aAAa;EACf;AACF,CAAC;EACC,6BAA6B;AAC/B,CAAC;EACC,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB,CAAC;EACC,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB,CAAC;EACC,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;AAC1C,CAAC;EACC;IACE,uBAAuB;EACzB;AACF,CAAC;EACC,eAAe;AACjB,CAAC;EACC,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB,CAAC;;EAEC,WAAW;EACX,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB,CAAC;;IAEG,WAAW;IACX,yBAAyB;EAC3B,CAAC;EACD,4BAA4B;AAC9B,CAAC;EACC,4BAA4B;AAC9B,CAAC;IACG,YAAY;IACZ,oBAAoB;EACtB,CAAC;IACC,YAAY;EACd,CAAC;IACC,gBAAgB;EAClB,CAAC;IACC,gBAAgB;EAClB,CAAC;;IAEC,6BAA6B;EAC/B,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,yBAAyB;EAC3B,CAAC;IACC,aAAa;EACf,CAAC;EACD,YAAY;EACZ,eAAe;EACf,YAAY;AACd,CAAC;EACC,0BAA0B;EAC1B,kBAAkB;AACpB,CAAC;EACC,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;;IAEZ,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd,CAAC;EACC;IACE,mBAAmB;EACrB;;IAEE;MACE,kBAAkB;MAClB,kBAAkB;MAClB,kBAAkB;MAClB,gBAAgB;IAClB;AACJ,CAAC;;EAEC,oBAAoB;EACpB,8CAA8C;AAChD,CAAC;;EAEC,oBAAoB;EACpB,8CAA8C;AAChD,CAAC;EACC,wBAAwB;EACxB,cAAc;EACd,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,CAAC;EACD,aAAa;EACb,CAAC;EACD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,CAAC;EACD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,sDAAsD;EACtD,kBAAkB;EAClB,UAAU;EACV,CAAC;EACD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,CAAC;EACD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,CAAC;EACD,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,CAAC;EACD,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,CAAC;EACD,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,CAAC;EACD,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,UAAU;EACV,CAAC;EACD,mBAAmB;EACnB,CAAC;EACD,mBAAmB;EACnB,CAAC;EACD,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB;EACA,CAAC;;;;;;EAMD,gBAAgB;EAChB,CAAC;EACD,gBAAgB;EAChB,CAAC;EACD,eAAe;EACf,gBAAgB;EAChB,CAAC;EACD,qBAAqB;EACrB,CAAC;EACD,eAAe;EACf,uBAAuB;EACvB,CAAC;EACD;EACA,mBAAmB;EACnB,sBAAsB;EACtB;EACA;EACA,2BAA2B;EAC3B;EACA;EACA,WAAW;EACX;EACA;EACA,UAAU;EACV,kBAAkB;EAClB;EACA;EACA,kBAAkB;EAClB,WAAW;EACX;EACA;EACA,SAAS;EACT;EACA;EACA,SAAS;EACT;EACA;EACA,oBAAoB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd;EACF,CAAC;EACD;EACA,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB;;EAEA;EACA,SAAS;EACT;;EAEA;EACA,WAAW;;EAEX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP;EACA;EACA,oBAAoB;EACpB,qBAAqB;EACrB;EACA;EACA,8BAA8B;EAC9B;EACA,CAAC;EACD;EACA,wRAAwR;EACxR;EACA,CAAC;EACD;EACA,4SAA4S;EAC5S,mTAAmT;EACnT,wRAAwR;EACxR;EACA,CAAC;EACD,gCAAgC;AAClC,CAAC;;QAEO,WAAW;QACX,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,kCAAkC;QAClC,+BAA+B;QAC/B,2BAA2B;QAC3B,UAAU;QACV,kBAAkB;QAClB,sDAAsD;MACxD,CAAC;QACC,2DAA2D;MAC7D,CAAC;MACD,oBAAoB;;MAEpB,qBAAqB;;MAErB,gBAAgB;;MAEhB,aAAa;;MAEb,gBAAgB;;MAEhB,gBAAgB;IAClB,CAAC;EACH,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB,CAAC;;QAEO,cAAc;QACd,YAAY;QACZ,kBAAkB;QAClB,yDAAyD;MAC3D,CAAC;EACL,kBAAkB;AACpB,CAAC,2BAA2B;IACxB,oBAAoB;EACtB;QACM,CAAC;IACL,aAAa;IACb,UAAU;EACZ,CAAC;MACG,SAAS;MACT,cAAc;IAChB,CAAC;EACH,oBAAoB;EACpB,8CAA8C;EAC9C,+BAA+B;EAC/B,cAAc;AAChB,CAAC;EACC,0BAA0B;AAC5B,CAAC;EACC,kBAAkB;EAClB,yDAAyD;AAC3D,CAAC;QACO,0DAA0D;MAC5D,CAAC;QACC,0DAA0D;MAC5D,CAAC;MACD;QACE,cAAc;QACd,QAAQ;QACR,kCAAkC;QAClC,gEAAgE;MAClE;IACF,CAAC;QACG,wBAAwB;MAC1B,CAAC;QACC,gCAAgC;MAClC,CAAC;EACL,uBAAuB;AACzB,CAAC;IACG,oBAAoB;IACpB,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,yDAAyD;EAC3D,CAAC,2BAA2B;MACxB,qBAAqB;MACrB,sBAAsB;MACtB;EACJ;IACE,CAAC,2BAA2B;MAC1B;EACJ;IACE,CAAC;MACC,gBAAgB;IAClB,CAAC,2BAA2B;QACxB;IACJ;MACE,CAAC;IACH,qBAAqB;EACvB,CAAC,gDAAgD,CAAC;;MAE9C,gBAAgB;MAChB,iBAAiB;IACnB,CAAC;;EAEH,kBAAkB;EAClB,uDAAuD;AACzD,CAAC;EACC,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;AAChB,CAAC;;;;QAIO,SAAS;QACT,OAAO;MACT,CAAC;EACL,UAAU;AACZ,CAAC;MACK,kBAAkB;MAClB,mBAAmB;MACnB,sBAAsB;MACtB,yDAAyD;IAC3D,CAAC;QACG,YAAY;MACd,CAAC;QACC,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,sDAAsD;;MAExD,CAAC;IACH,6BAA6B;EAC/B,CAAC;QACK,qDAAqD;QACrD,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;MACnB,CAAC,2BAA2B;UACxB;MACJ;QACE,CAAC;IACL,6DAA6D;EAC/D,CAAC,2BAA2B;MACxB;EACJ;IACE,CAAC;MACC,WAAW;MACX,wBAAwB;MACxB,UAAU;MACV,SAAS;MACT,yBAAyB;MACzB,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,kBAAkB;IACpB,CAAC,2BAA2B;QACxB,UAAU;QACV,uBAAuB;QACvB;IACJ;MACE,CAAC,0BAA0B;IAC7B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB,CAAC,0BAA0B;MACvB,gBAAgB;IAClB;EACF,CAAC,0BAA0B;MACvB,gBAAgB;IAClB;EACF,CAAC,0BAA0B;MACvB,gBAAgB;IAClB;EACF,CAAC,2BAA2B;MACxB,iBAAiB;IACnB;EACF;AACF,CAAC;EACC,6BAA6B;EAC7B,oEAAoE;AACtE,CAAC;EACC,iCAAiC;EACjC,yCAAyC;EACzC,kHAAkH;AACpH,CAAC;EACC,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;AAChC,CAAC;EACC,gCAAgC;AAClC,CAAC;EACC,wBAAwB;AAC1B,CAAC,0BAA0B;IACvB,2BAA2B;EAC7B,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,gCAAgC;EAClC,CAAC;IACC,6BAA6B;IAC7B,8BAA8B;EAChC,CAAC;IACC,6BAA6B;EAC/B;AACF,CAAC,0BAA0B;IACvB,4BAA4B;EAC9B,CAAC;IACC,wBAAwB;EAC1B,CAAC;IACC,2BAA2B;EAC7B,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,wCAAwC;EAC1C,CAAC;IACC,wBAAwB;EAC1B,CAAC;IACC,4BAA4B;IAC5B,+BAA+B;EACjC,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,yBAAyB;EAC3B,CAAC;IACC,4BAA4B;EAC9B,CAAC;IACC,8BAA8B;EAChC;AACF,CAAC,0BAA0B;IACvB,2BAA2B;EAC7B,CAAC;IACC,sBAAsB;EACxB,CAAC;IACC,sBAAsB;EACxB,CAAC;IACC,gCAAgC;EAClC,CAAC;IACC,gCAAgC;EAClC,CAAC;IACC,gCAAgC;EAClC,CAAC;IACC,wBAAwB;EAC1B,CAAC;IACC,yBAAyB;EAC3B,CAAC;IACC,gCAAgC;EAClC,CAAC;IACC,wBAAwB;EAC1B,CAAC;IACC,wBAAwB;EAC1B,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,2BAA2B;EAC7B,CAAC;IACC,qBAAqB;EACvB,CAAC;IACC,2BAA2B;EAC7B,CAAC;IACC,sBAAsB;EACxB,CAAC;IACC,0BAA0B;EAC5B,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,6BAA6B;IAC7B,oEAAoE;EACtE,CAAC;IACC,wCAAwC;EAC1C,CAAC;IACC,4BAA4B;EAC9B,CAAC;IACC,+BAA+B;EACjC,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,8BAA8B;EAChC,CAAC;IACC,yBAAyB;EAC3B,CAAC;IACC,4BAA4B;EAC9B,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,0BAA0B;EAC5B,CAAC;IACC,6BAA6B;EAC/B,CAAC;IACC,2BAA2B;EAC7B;AACF","sourcesContent":["\n\n\n@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@100;400;500;600;700;900&display=swap');/*\n! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com\n*//*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: currentColor; /* 2 */\n}::before,\n::after {\n  --tw-content: '';\n}/*\n1. Use a consistent sensible line-height in all browsers.\n2. Prevent adjustments of font size after orientation changes in iOS.\n3. Use a more readable tab size.\n4. Use the user's configured `sans` font-family by default.\n5. Use the user's configured `sans` font-feature-settings by default.\n6. Use the user's configured `sans` font-variation-settings by default.\n*/html {\n  line-height: 1.5; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n  -moz-tab-size: 4; /* 3 */\n  tab-size: 4; /* 3 */\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 4 */\n  font-feature-settings: normal; /* 5 */\n  font-variation-settings: normal; /* 6 */\n}/*\n1. Remove the margin in all browsers.\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\n*/body {\n  margin: 0; /* 1 */\n  line-height: inherit; /* 2 */\n}/*\n1. Add the correct height in Firefox.\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n3. Ensure horizontal rules are visible by default.\n*/hr {\n  height: 0; /* 1 */\n  color: inherit; /* 2 */\n  border-top-width: 1px; /* 3 */\n}/*\nAdd the correct text decoration in Chrome, Edge, and Safari.\n*/abbr:where([title]) {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n}/*\nRemove the default font size and weight for headings.\n*/h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}/*\nReset links to optimize for opt-in styling instead of opt-out.\n*/a {\n  color: inherit;\n  text-decoration: inherit;\n}/*\nAdd the correct font weight in Edge and Safari.\n*/b,\nstrong {\n  font-weight: bolder;\n}/*\n1. Use the user's configured `mono` font family by default.\n2. Correct the odd `em` font sizing in all browsers.\n*/code,\nkbd,\nsamp,\npre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}/*\nAdd the correct font size in all browsers.\n*/small {\n  font-size: 80%;\n}/*\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/sub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}sub {\n  bottom: -0.25em;\n}sup {\n  top: -0.5em;\n}/*\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n3. Remove gaps between table borders by default.\n*/table {\n  text-indent: 0; /* 1 */\n  border-color: inherit; /* 2 */\n  border-collapse: collapse; /* 3 */\n}/*\n1. Change the font styles in all browsers.\n2. Remove the margin in Firefox and Safari.\n3. Remove default padding in all browsers.\n*/button,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-feature-settings: inherit; /* 1 */\n  font-variation-settings: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  font-weight: inherit; /* 1 */\n  line-height: inherit; /* 1 */\n  color: inherit; /* 1 */\n  margin: 0; /* 2 */\n  padding: 0; /* 3 */\n}/*\nRemove the inheritance of text transform in Edge and Firefox.\n*/button,\nselect {\n  text-transform: none;\n}/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Remove default button styles.\n*/button,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button; /* 1 */\n  background-color: transparent; /* 2 */\n  background-image: none; /* 2 */\n}/*\nUse the modern Firefox focus style for all focusable elements.\n*/:-moz-focusring {\n  outline: auto;\n}/*\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/:-moz-ui-invalid {\n  box-shadow: none;\n}/*\nAdd the correct vertical alignment in Chrome and Firefox.\n*/progress {\n  vertical-align: baseline;\n}/*\nCorrect the cursor style of increment and decrement buttons in Safari.\n*/::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  height: auto;\n}/*\n1. Correct the odd appearance in Chrome and Safari.\n2. Correct the outline style in Safari.\n*/[type='search'] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}/*\nRemove the inner padding in Chrome and Safari on macOS.\n*/::-webkit-search-decoration {\n  -webkit-appearance: none;\n}/*\n1. Correct the inability to style clickable types in iOS and Safari.\n2. Change font properties to `inherit` in Safari.\n*/::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}/*\nAdd the correct display in Chrome and Safari.\n*/summary {\n  display: list-item;\n}/*\nRemoves the default spacing and border for appropriate elements.\n*/blockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}fieldset {\n  margin: 0;\n  padding: 0;\n}legend {\n  padding: 0;\n}ol,\nul,\nmenu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}/*\nReset default styling for dialogs.\n*/dialog {\n  padding: 0;\n}/*\nPrevent resizing textareas horizontally by default.\n*/textarea {\n  resize: vertical;\n}/*\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n2. Set the default placeholder color to the user's configured gray 400 color.\n*/input::placeholder,\ntextarea::placeholder {\n  opacity: 1; /* 1 */\n  color: #9ca3af; /* 2 */\n}/*\nSet the default cursor for buttons.\n*/button,\n[role=\"button\"] {\n  cursor: pointer;\n}/*\nMake sure disabled buttons don't get the pointer cursor.\n*/:disabled {\n  cursor: default;\n}/*\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n   This can trigger a poorly considered lint error in some tools but is included by design.\n*/img,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block; /* 1 */\n  vertical-align: middle; /* 2 */\n}/*\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/img,\nvideo {\n  max-width: 100%;\n  height: auto;\n}/* Make elements with the HTML hidden attribute stay hidden by default */[hidden] {\n  display: none;\n}*, ::before, ::after{\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}::backdrop{\n  --tw-border-spacing-x: 0;\n  --tw-border-spacing-y: 0;\n  --tw-translate-x: 0;\n  --tw-translate-y: 0;\n  --tw-rotate: 0;\n  --tw-skew-x: 0;\n  --tw-skew-y: 0;\n  --tw-scale-x: 1;\n  --tw-scale-y: 1;\n  --tw-pan-x:  ;\n  --tw-pan-y:  ;\n  --tw-pinch-zoom:  ;\n  --tw-scroll-snap-strictness: proximity;\n  --tw-gradient-from-position:  ;\n  --tw-gradient-via-position:  ;\n  --tw-gradient-to-position:  ;\n  --tw-ordinal:  ;\n  --tw-slashed-zero:  ;\n  --tw-numeric-figure:  ;\n  --tw-numeric-spacing:  ;\n  --tw-numeric-fraction:  ;\n  --tw-ring-inset:  ;\n  --tw-ring-offset-width: 0px;\n  --tw-ring-offset-color: #fff;\n  --tw-ring-color: rgb(59 130 246 / 0.5);\n  --tw-ring-offset-shadow: 0 0 #0000;\n  --tw-ring-shadow: 0 0 #0000;\n  --tw-shadow: 0 0 #0000;\n  --tw-shadow-colored: 0 0 #0000;\n  --tw-blur:  ;\n  --tw-brightness:  ;\n  --tw-contrast:  ;\n  --tw-grayscale:  ;\n  --tw-hue-rotate:  ;\n  --tw-invert:  ;\n  --tw-saturate:  ;\n  --tw-sepia:  ;\n  --tw-drop-shadow:  ;\n  --tw-backdrop-blur:  ;\n  --tw-backdrop-brightness:  ;\n  --tw-backdrop-contrast:  ;\n  --tw-backdrop-grayscale:  ;\n  --tw-backdrop-hue-rotate:  ;\n  --tw-backdrop-invert:  ;\n  --tw-backdrop-opacity:  ;\n  --tw-backdrop-saturate:  ;\n  --tw-backdrop-sepia:  ;\n}.container{\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}@media (min-width: 576px){.container{\n    max-width: 576px;\n  }\n}@media (min-width: 768px){.container{\n    max-width: 768px;\n  }\n}@media (min-width: 992px){.container{\n    max-width: 992px;\n  }\n}@media (min-width: 1200px){.container{\n    max-width: 1200px;\n  }\n}.sr-only{\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border-width: 0 !important;\n}.pointer-events-none{\n  pointer-events: none !important;\n}.visible{\n  visibility: visible !important;\n}.static{\n  position: static !important;\n}.fixed{\n  position: fixed !important;\n}.absolute{\n  position: absolute !important;\n}.relative{\n  position: relative !important;\n}.sticky{\n  position: sticky !important;\n}.bottom-0{\n  bottom: 0 !important;\n}.left-0{\n  left: 0 !important;\n}.right-0{\n  right: 0 !important;\n}.top-0{\n  top: 0 !important;\n}.top-32{\n  top: 8rem !important;\n}.z-10{\n  z-index: 10 !important;\n}.m-auto{\n  margin: auto !important;\n}.mx-auto{\n  margin-left: auto !important;\n  margin-right: auto !important;\n}.my-2{\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}.my-4{\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}.my-8{\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}.-mt-2{\n  margin-top: -0.5rem !important;\n}.mb-0{\n  margin-bottom: 0 !important;\n}.mb-1{\n  margin-bottom: 0.25rem !important;\n}.mb-10{\n  margin-bottom: 2.5rem !important;\n}.mb-2{\n  margin-bottom: 0.5rem !important;\n}.mb-4{\n  margin-bottom: 1rem !important;\n}.mb-6{\n  margin-bottom: 1.5rem !important;\n}.ml-0{\n  margin-left: 0 !important;\n}.ml-2{\n  margin-left: 0.5rem !important;\n}.mr-0{\n  margin-right: 0 !important;\n}.mr-2{\n  margin-right: 0.5rem !important;\n}.mt-10{\n  margin-top: 2.5rem !important;\n}.mt-12{\n  margin-top: 3rem !important;\n}.mt-24{\n  margin-top: 6rem !important;\n}.mt-6{\n  margin-top: 1.5rem !important;\n}.mt-8{\n  margin-top: 2rem !important;\n}.block{\n  display: block !important;\n}.inline-block{\n  display: inline-block !important;\n}.inline{\n  display: inline !important;\n}.flex{\n  display: flex !important;\n}.table{\n  display: table !important;\n}.contents{\n  display: contents !important;\n}.hidden{\n  display: none !important;\n}.h-full{\n  height: 100% !important;\n}.w-1\\/2{\n  width: 50% !important;\n}.w-1\\/3{\n  width: 33.33333% !important;\n}.w-1\\/4{\n  width: 25% !important;\n}.w-2\\/3{\n  width: 66.66667% !important;\n}.w-full{\n  width: 100% !important;\n}.max-w-2xl{\n  max-width: 42rem !important;\n}.max-w-3xl{\n  max-width: 48rem !important;\n}.max-w-md{\n  max-width: 28rem !important;\n}.max-w-xs{\n  max-width: 20rem !important;\n}.transform{\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;\n}.cursor-pointer{\n  cursor: pointer !important;\n}.select-none{\n  -webkit-user-select: none !important;\n          user-select: none !important;\n}.flex-col{\n  flex-direction: column !important;\n}.flex-wrap{\n  flex-wrap: wrap !important;\n}.items-end{\n  align-items: flex-end !important;\n}.items-center{\n  align-items: center !important;\n}.justify-end{\n  justify-content: flex-end !important;\n}.justify-center{\n  justify-content: center !important;\n}.justify-between{\n  justify-content: space-between !important;\n}.overflow-hidden{\n  overflow: hidden !important;\n}.rounded-lg{\n  border-radius: .5rem !important;\n}.rounded-none{\n  border-radius: 0 !important;\n}.border-2{\n  border-width: 2px !important;\n}.border-b-2{\n  border-bottom-width: 2px !important;\n}.border-l-2{\n  border-left-width: 2px !important;\n}.border-none{\n  border-style: none !important;\n}.border-green{\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(10 118 58 / var(--tw-border-opacity)) !important;\n}.border-green-light{\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(11 173 127 / var(--tw-border-opacity)) !important;\n}.border-grey{\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(157 166 186 / var(--tw-border-opacity)) !important;\n}.border-grey-light{\n  --tw-border-opacity: 1 !important;\n  border-color: rgb(228 230 235 / var(--tw-border-opacity)) !important;\n}.bg-green{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(10 118 58 / var(--tw-bg-opacity)) !important;\n}.bg-green-dark{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(15 97 93 / var(--tw-bg-opacity)) !important;\n}.bg-green-light{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(11 173 127 / var(--tw-bg-opacity)) !important;\n}.bg-grey-figma{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n}.bg-grey-figma-dark{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(236 236 236 / var(--tw-bg-opacity)) !important;\n}.bg-red{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 72 86 / var(--tw-bg-opacity)) !important;\n}.bg-transparent{\n  background-color: transparent !important;\n}.bg-white{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;\n}.bg-yellow{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(255 163 0 / var(--tw-bg-opacity)) !important;\n}.bg-none{\n  background-image: none !important;\n}.bg-cover{\n  background-size: cover !important;\n}.bg-center{\n  background-position: center !important;\n}.bg-no-repeat{\n  background-repeat: no-repeat !important;\n}.object-contain{\n  object-fit: contain !important;\n}.object-cover{\n  object-fit: cover !important;\n}.object-center{\n  object-position: center !important;\n}.p-2{\n  padding: 0.5rem !important;\n}.p-4{\n  padding: 1rem !important;\n}.p-6{\n  padding: 1.5rem !important;\n}.px-12{\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}.px-16{\n  padding-left: 4rem !important;\n  padding-right: 4rem !important;\n}.px-2{\n  padding-left: 0.5rem !important;\n  padding-right: 0.5rem !important;\n}.px-4{\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}.px-8{\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}.py-1{\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}.py-2{\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}.py-24{\n  padding-top: 6rem !important;\n  padding-bottom: 6rem !important;\n}.py-3{\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}.py-4{\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}.pb-6{\n  padding-bottom: 1.5rem !important;\n}.pl-0{\n  padding-left: 0 !important;\n}.pl-1{\n  padding-left: 0.25rem !important;\n}.pl-2{\n  padding-left: 0.5rem !important;\n}.pl-4{\n  padding-left: 1rem !important;\n}.pl-5{\n  padding-left: 1.25rem !important;\n}.pr-1{\n  padding-right: 0.25rem !important;\n}.pr-12{\n  padding-right: 3rem !important;\n}.pr-2{\n  padding-right: 0.5rem !important;\n}.pr-4{\n  padding-right: 1rem !important;\n}.pt-10{\n  padding-top: 2.5rem !important;\n}.pt-12{\n  padding-top: 3rem !important;\n}.pt-2{\n  padding-top: 0.5rem !important;\n}.pt-20{\n  padding-top: 5rem !important;\n}.pt-32{\n  padding-top: 8rem !important;\n}.pt-4{\n  padding-top: 1rem !important;\n}.pt-8{\n  padding-top: 2rem !important;\n}.text-left{\n  text-align: left !important;\n}.text-center{\n  text-align: center !important;\n}.text-right{\n  text-align: right !important;\n}.text-2xl{\n  font-size: 1.5rem !important;\n}.text-3xl{\n  font-size: 1.875rem !important;\n}.text-base{\n  font-size: 1rem !important;\n}.text-sm{\n  font-size: .9375rem !important;\n}.text-xl{\n  font-size: 1.25rem !important;\n}.text-xs{\n  font-size: .75rem !important;\n}.font-black{\n  font-weight: 900 !important;\n}.font-bold{\n  font-weight: 700 !important;\n}.font-light{\n  font-weight: 300 !important;\n}.font-semibold{\n  font-weight: 600 !important;\n}.font-thin{\n  font-weight: 200 !important;\n}.lowercase{\n  text-transform: lowercase !important;\n}.leading-none{\n  line-height: 1 !important;\n}.leading-tight{\n  line-height: 1.25 !important;\n}.text-black{\n  --tw-text-opacity: 1 !important;\n  color: rgb(39 39 39 / var(--tw-text-opacity)) !important;\n}.text-green{\n  --tw-text-opacity: 1 !important;\n  color: rgb(10 118 58 / var(--tw-text-opacity)) !important;\n}.text-green-dark{\n  --tw-text-opacity: 1 !important;\n  color: rgb(15 97 93 / var(--tw-text-opacity)) !important;\n}.text-green-light{\n  --tw-text-opacity: 1 !important;\n  color: rgb(11 173 127 / var(--tw-text-opacity)) !important;\n}.text-grey{\n  --tw-text-opacity: 1 !important;\n  color: rgb(157 166 186 / var(--tw-text-opacity)) !important;\n}.text-grey-dark{\n  --tw-text-opacity: 1 !important;\n  color: rgb(80 95 118 / var(--tw-text-opacity)) !important;\n}.text-purple{\n  --tw-text-opacity: 1 !important;\n  color: rgb(81 26 146 / var(--tw-text-opacity)) !important;\n}.text-red{\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 72 86 / var(--tw-text-opacity)) !important;\n}.text-red-lighter{\n  --tw-text-opacity: 1 !important;\n  color: rgb(249 172 170 / var(--tw-text-opacity)) !important;\n}.text-white{\n  --tw-text-opacity: 1 !important;\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\n}.opacity-0{\n  opacity: 0 !important;\n}.shadow-lg{\n  --tw-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08) !important;\n  --tw-shadow-colored: 0 15px 30px 0 var(--tw-shadow-color), 0 5px 15px 0 var(--tw-shadow-color) !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}.outline{\n  outline-style: solid !important;\n}.transition{\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter !important;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter !important;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;\n  transition-duration: 150ms !important;\n}html {\n  font-family: 'Urbanist', sans-serif;\n  /* color: #272727; */\n  color: #505f76;\n}.button {\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);\n  border-radius: .25rem;\n  border: 2px solid transparent;\n  font-weight: 500;\n}.nav-primary .button {\n  padding: 1rem .75rem;\n}.button:active,.button:focus {\n  outline: none\n}.button.button-submit {\n  background-color: #fc968b;\n  color: #fff;\n  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);\n  padding-top: .75rem;\n  padding-bottom: .75rem\n}.button.button-submit:hover {\n  background-color: #f9acaa\n}.bg-yellow {\n  background-color: #ffa300;\n}h1, h2 {\n  font-size: 2.5rem;\n  line-height: 2.8rem;\n  font-weight: 500;\n}.text-green {\n  color: #007d33;\n}.border-red {\n  border-color: #ff4856 !important;\n}.bg-red-lightblank {\n  background-color: #ffe4e6;\n}.anchor-in-menu a {\n  display: block;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,.1);\n  font-weight: 600;\n  font-size: .9375rem;\n  padding: 1rem 0.75rem;\n  border-radius: 0.25rem;\n  border: 2px solid transparent;\n}.anchor-in-menu.button-red a {\n  background-color: #ff4856;\n}.anchor-in-menu.button-yellow a {\n  background-color: #ffa300;\n}@media screen and (min-width: 992px) {\n  .anchor-in-menu a {\n    display: inline-block;\n  }\n}.get-scale {\n  transform: scale(1);\n  transition: 0.2s;\n}.get-scale:hover {\n    filter: opacity(0.5);\n    transform: scale(var(--scale));\n  }/* inViewport */[data-inviewport=\"scale-in\"] {\n  transition: 1s;\n  transform: scale(0.1);\n}[data-inviewport=\"scale-in\"].is-inViewport {\n  transform: scale(1);\n}[data-inviewport=\"right-in\"] {\n  transition: 1s;\n  transform: translate(30%, 0);\n}[data-inviewport=\"right-in\"].is-inViewport {\n  transform: translate(0, 0);\n}[data-inviewport=\"crawl-in\"] {\n  transition: 1s;\n  transform: translate(0, 30%);\n}[data-inviewport=\"crawl-in\"].is-inViewport {\n  transform: translate(0, 0);\n}[data-inviewport=\"fade-in\"] {\n  transition: 1s;\n  opacity: 0;\n}[data-inviewport=\"fade-in\"].is-inViewport {\n  opacity: 1;\n}[data-inviewport=\"bg-in\"] {\n  transition: 1s;\n  background-size: 130% 130%;\n}[data-inviewport=\"bg-in\"].is-inViewport {\n  background-size: 100% 100%;\n}.bg-alt-resource a {\n  font-size: 1rem !important;\n  background: none;\n  border: 2px solid white;\n  box-shadow: none;\n}.bg-alt-resource a:hover {\n  transition: 0.2s;\n  background: white;\n  color: #0f615d;\n}.bg-green-light {\n  background-color: #0bad7f;\n}.hamburger {\n  cursor: pointer;\n  transform: rotate(0);\n  transition: 0.5s ease-in-out;\n  width: 24px;\n  height: 28px;\n  z-index: 3;\n}.hamburger div {\n    background: #272727;\n    border-radius: 9px;\n    display: block;\n    height: 1px;\n    left: -10px;\n    position: absolute;\n    transform: rotate(0);\n    transition: 0.25s ease-in-out;\n    width: calc(100% + 5px);\n  }.hamburger div:nth-child(1) {\n      top: 9px;\n    }.hamburger div:nth-child(2),\n    .hamburger div:nth-child(3) {\n      top: 18px;\n    }.hamburger div:nth-child(4) {\n      top: 27px;\n    }.hamburger.open {\n    z-index: 10;\n    transform: scale(0.7) translate(-12px, -2px);\n  }.hamburger.open div:nth-child(1),\n      .hamburger.open div:nth-child(4) {\n        left: 50%;\n        top: 18px;\n        width: 0%;\n      }.hamburger.open div:nth-child(2) {\n        transform: rotate(45deg);\n      }.hamburger.open div:nth-child(3) {\n        transform: rotate(-45deg);\n      }.accordion-content ul {\n    list-style: disc;\n    margin-left: 18px;\n  }.accordion-content ol {\n    list-style: auto;\n    margin-left: 18px;\n  }.accordion-content ul {\n\t\tlist-style: disc;\n\t\tmargin-left: 18px;\n\t}.accordion-content ol {\n\t\tlist-style: decimal;\n\t\tmargin-left: 18px;\n\t}.anchor-in-menu.button-green-light a {\n  background-color: #38b981;\n}.anchor-in-menu ul.sub-menu {\n    pointer-events: none;\n\t\tposition: absolute;\n\t\tmax-width: 100%;\n\t\tborder: 2px solid #ff4856;\n\t\tbackground-color: white;\n\t\tborder-top: none;\n\t\ttransform: translate(0px, -58px);\n\t\tz-index: -1;\n\t\topacity: 0;\n\t\ttransition: 0.2s;\n\t}.anchor-in-menu ul.sub-menu li a:hover {\n\t\t\t\t\tcolor: white;\n\t\t\t\t}.anchor-in-menu ul.sub-menu li a:hover:before {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}.anchor-in-menu ul.sub-menu li a:before {\n\t\t\t\t\tcontent: '';\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tz-index: -1;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tbackground: #ff4856;\n\t\t\t\t\ttop: 0;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttransition: 0.2s;\n\t\t\t\t}.anchor-in-menu ul.sub-menu li a{\n\t\t\t\tbackground: none;\n\t\t\t\tborder: 0;\n\t\t\t\tbox-shadow: none;\n\t\t\t\tcolor: black;\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tpadding: 1rem 1.75rem;\n}.anchor-in-menu:hover ul.sub-menu {\n      pointer-events: all;\n\t\t\ttransform: translate(0px, 0px);\n\t\t\topacity: 1;\n\t\t\tborder-radius: 0px 0px 14px 14px;\n\t\t\toverflow: hidden;\n\t\t\tborder-top: 0 !important;\n\t\t\tposition: relative;\n\t\t\tz-index: 99999;\n\t\t}.anchor-in-menu.button-red ul.sub-menu {\n\t\tborder: 2px solid #ff4856;\n\t}.anchor-in-menu.button-red ul.sub-menu li a:before {\n\t\t\t\t\tbackground: #ff4856;\n\t\t\t\t}.anchor-in-menu.button-red ul.sub-menu li:not(:last-child) {\n\t\t\t\tborder-bottom: 2px solid #fed2d6;\n\t\t\t}.anchor-in-menu.button-yellow ul.sub-menu {\n\t\tborder: 2px solid #ffa300;\n\t}.anchor-in-menu.button-yellow ul.sub-menu li a:before {\n\t\t\t\t\tbackground: #ffa300;\n\t\t\t\t}.anchor-in-menu.button-yellow ul.sub-menu li:not(:last-child) {\n\t\t\t\tborder-bottom: 2px solid #ffe5b9;\n\t\t\t}.anchor-in-menu.menu-item-has-children >a:after {\n\t\t\tcontent: \"\";\n\t\t\tmargin-left: 15px;\n\t\t\tdisplay: inline-block;\n\t\t\tborder-left: 2px solid #fff;\n\t\t\tborder-bottom: 2px solid #fff;\n\t\t\twidth: 10px;\n\t\t\theight: 10px;\n\t\t\ttransform: rotate(-45deg);\n\t\t\ttransition: 0.2s;\n\t\t\tfloat: right;\n\t\t}.anchor-in-menu.menu-item-has-children:hover >a:after {\n\t\t\t\ttransform: rotate(135deg);\n\t\t\t}.anchor-in-menu.menu-item-has-children.first-anchor >a {\n\t\tpointer-events: none;\n\t}.mdhidden {\n  display: block;\n}@media screen and (min-width: 992px) {\n\t\t.anchor-in-menu.menu-item-has-children >a {\n\t\t\tpointer-events: all !important;\n\t\t}\n\t\t\t.anchor-in-menu.menu-item-has-children >a:after {\n\t\t\t\tfloat: none;\n\t\t\t}\n\t\t\t.anchor-in-menu:hover ul.sub-menu {\n\t\t\t\tposition: absolute;\n\t\t\t\tz-index: 1;\n\t\t\t}\n  .mdhidden {\n    display: none;\n  }\n}.single-chart {\n  justify-content: space-around;\n}.circular-chart {\n  display: block;\n  margin: 10px auto;\n  max-width: 50%;\n  max-height: 250px;\n}.circle-bg {\n  fill: none;\n  stroke: #eee;\n  stroke-width: 3.8;\n}.circle {\n  fill: none;\n  stroke-width: 3.8;\n  stroke-linecap: round;\n  animation: progress 1s ease-out forwards;\n}@keyframes progress {\n  0% {\n    stroke-dasharray: 0 100;\n  }\n}.circular-chart .circle {\n  stroke: #80d080;\n}.percentage {\n  fill: white;\n  font-size: 0.5em;\n  text-anchor: middle;\n  font-weight: bold;\n}.semi-circle-wrap::before,\n.semi-circle-wrap::after {\n  content: '';\n  height: 100px;\n  width: 100%;\n  background-color: #0f615d;\n  display: block;\n}.semi-circle-wrap--grey::before,\n  .semi-circle-wrap--grey::after {\n    content: '';\n    background-color: #f2f2f2;\n  }.semi-circle-wrap::before {\n  border-radius: 100% 100% 0 0;\n}.semi-circle-wrap::after {\n  border-radius: 0 0 100% 100%;\n}.semi-circle-wrap--smalltop::before {\n    height: 60px;\n    margin-bottom: -25px;\n  }.semi-circle-wrap--smallbottom::after {\n    height: 60px;\n  }.semi-circle-wrap--nobottom::after {\n    border-radius: 0;\n  }.semi-circle-wrap--notop::before {\n    border-radius: 0;\n  }.semi-circle-wrap.bg-transparent::before,\n  .semi-circle-wrap.bg-transparent::after {\n    background-color: transparent;\n  }.semi-circle-wrap.bg-transparent .bg-green-dark {\n    background-color: transparent;\n  }.semi-circle-wrap.bg-transparent .text-white {\n    color: #0f615d !important;\n  }.semi-circle-wrap.bg-transparent .percentage {\n    fill: #0f615d;\n  }.snazzy-list_wrapper {\n  width: 500px;\n  max-width: 100%;\n  margin: auto;\n}.snazzy-list {\n  counter-increment: section;\n  position: relative;\n}.snazzy-list::before{\n  --tw-text-opacity: 1;\n  color: rgb(10 118 58 / var(--tw-text-opacity));\n  color: #007d33;\n\n    content: counter(section);\n    right: 100%;\n    margin-right: 1px;\n    margin-top: 0;\n    border-radius: 50%;\n    padding: 10px;\n    height: 100px;\n    width: 100px;\n    text-align: left;\n    font-size: 3rem;\n    font-weight: 900;\n    opacity: 1;\n}@media (min-width: 992px) {\n  .snazzy-list {\n    margin-bottom: 58px;\n  }\n\n    .snazzy-list::before {\n      margin-top: -110px;\n      text-align: center;\n      position: absolute;\n      font-size: 10rem;\n    }\n}.snazzy-list:nth-child(2)::before,\n.snazzy-list:nth-child(5n)::before{\n  --tw-text-opacity: 1;\n  color: rgb(255 72 86 / var(--tw-text-opacity));\n}.snazzy-list:nth-child(3)::before,\n.snazzy-list:nth-child(6n)::before{\n  --tw-text-opacity: 1;\n  color: rgb(255 163 0 / var(--tw-text-opacity));\n}.tronc-compare-wrapper input[type=range] {\n  -webkit-appearance: none;\n  margin: 18px 0;\n  width: 100%;\n  z-index: 2;\n  position: relative;\n  }.tronc-compare-wrapper input[type=range]:focus {\n  outline: none;\n  }.tronc-compare-wrapper input[type=range]::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 12px;\n  cursor: pointer;\n  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;\n  background: transparent;\n  border-radius: 5px;\n  border: 0.2px solid #fff;\n  }.tronc-compare-wrapper input[type=range]::-webkit-slider-thumb {\n  height: 25px;\n  width: 25px;\n  border-radius: 100%;\n  background: #0bad7f;\n  cursor: pointer;\n  -webkit-appearance: none;\n  margin-top: -8px;\n  box-shadow: 0px 0px 0px 2px #fff, 0px 0px 0px 2px #fff;\n  position: relative;\n  z-index: 3;\n  }.tronc-compare-wrapper input[type=range]::-moz-range-track {\n  width: 100%;\n  height: 12px;\n  cursor: pointer;\n  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;\n  background: transparent;\n  border-radius: 5px;\n  border: 0.2px solid #fff;\n  }.tronc-compare-wrapper input[type=range]::-moz-range-thumb {\n  height: 25px;\n  width: 25px;\n  border-radius: 100%;\n  background: #0bad7f;\n  cursor: pointer;\n  border: 2px solid white;\n  position: relative;\n  z-index: 3;\n  }.tronc-compare-wrapper input[type=range]::-ms-track {\n  width: 100%;\n  height: 12px;\n  cursor: pointer;\n  background: transparent;\n  border-color: transparent;\n  border-width: 16px 0;\n  color: transparent;\n  }.tronc-compare-wrapper input[type=range]::-ms-fill-lower {\n  background: #0bad7f;\n  border: 0.2px solid #fff;\n  border-radius: 2.6px;\n  }.tronc-compare-wrapper input[type=range]::-ms-fill-upper {\n  background: #0a763a;\n  border: 0.2px solid #fff;\n  border-radius: 2.6px;\n  border: 2px solid white;\n  }.tronc-compare-wrapper input[type=range]::-ms-thumb {\n  height: 25px;\n  width: 25px;\n  border-radius: 100%;\n  background: #0bad7f;\n  cursor: pointer;\n  border: 2px solid white;\n  box-shadow: 1px 1px 1px #fff, 0px 0px 1px #fff;\n  position: relative;\n  z-index: 3;\n  }.tronc-compare-wrapper input[type=range]:focus::-ms-fill-lower {\n  background: #0bad7f;\n  }.tronc-compare-wrapper input[type=range]:focus::-ms-fill-upper {\n  background: #0bad7f;\n  }.range-bg {\n  width: 100%;\n  height: 12px;\n  background: #fafafa;\n  position: absolute;\n  z-index: 1;\n  border-radius: 5px;\n  border: 1px solid #ececec\n  }.tronc-compare-wrapper input[type=range]:active::-webkit-slider-runnable-track, input[type=range]:focus::-webkit-slider-runnable-track,\n  .tronc-compare-wrapper input[type=range]:active::-moz-range-thumb, input[type=range]:focus::-moz-range-thumb,\n  .tronc-compare-wrapper input[type=range]:active::-ms-thumb, input[type=range]:focus::-ms-thumb,\n  .tronc-compare-wrapper input[type=range]:active::-ms-track, input[type=range]:focus::-ms-track,\n  .tronc-compare-wrapper input[type=range]:active::-moz-range-track, input[type=range]:focus::-moz-range-track,\n  .tronc-compare-wrapper input[type=range]:active::-webkit-slider-thumb, input[type=range]:focus::-webkit-slider-thumb {\n  cursor: grabbing;\n  }.tronc-compare .maximage {\n  max-height: 65px;\n  }.tronc-compare #comparison-table .head {\n  padding-left: 0;\n  padding-right: 0;\n  }.userInput:hover svg {\n  display: inline-block;\n  }.userInput svg {\n  display: hidden;\n  background-color: white;\n  }@media screen and (max-width: 992px) {\n  .tronc-compare .accordion .accordion-trigger.reverse {\n  padding-top: 0.8rem;\n  padding-bottom: 0.8rem;\n  }\n  .bg-gone {\n  background: none !important;\n  }\n  .outline-tronc {\n  height: 75%;\n  }\n  .employee-heading {\n  top: -14px;\n  position: absolute;\n  }\n  .alterative-em {\n  position: absolute;\n  z-index: 21;\n  }\n  .tronc-compare #comparison-table .head.main-stick {\n  top: 88px;\n  }\n  .tronc-compare #comparison-table .head.main-stick.top-32 {\n  top: 51px;\n  }\n  .first-bracket p {\n  padding-bottom: 25px;\n  }\n\n  .wp-block-tronculator {\n    max-width: 95%;\n    margin: 0 auto;\n    }\n  }@media screen and (min-width: 992px) {\n  .tronc-compare #comparison-table .head.main-stick {\n  top: 103px;\n  z-index: 21;\n  background: none;\n  }\n  \n  .tronc-compare #comparison-table .head.main-stick.top-32 {\n  top: 55px;\n  }\n  \n  .tronc-compare .main-stick:before {\n  content: '';\n  \n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  }\n  .tronc-compare #comparison-table .head {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  }\n  .transform-small {\n  transform: translate(5px, 0px);\n  }\n  }@media screen and (min-width: 1200px) {\n  .tronc-compare .main-stick:before {\n  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) 33.33333%, rgb(250 250 250) 33.33333% , rgb(250 250 250) 50%, rgb(250 250 250) 50%, rgb(250 250 250) 66.66667%,rgba(11,173,127,1) 66.66667%, rgba(11,173,127,1) 83.44334%,rgba(250,250,250,1) 83.44334%);  */\n  }\n  }@media screen and (min-width: 992px) and (max-width: 1199px) {\n  .tronc-compare .main-stick:before {\n  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) calc(100% - 634.5px), rgb(250 250 250) calc(100% - 634.5px), rgb(250 250 250) calc(100% - 316.5px),rgba(11,173,127,1) calc(100% - 316.5px), rgba(11,173,127,1) calc(100% - 156.5px),rgba(250,250,250,1) calc(100% - 156.5px)); */\n  /* background: linear-gradient(90deg, rgb(255 255 255) 0vw, rgb(255 255 255) calc(100vw - 715.5px), rgb(250 250 250) calc(100vw - 715.5px), rgb(250 250 250) calc(100vw - 398.5px),rgba(11,173,127,1) calc(100vw - 398.5px), rgba(11,173,127,1) calc(100vw - 237.5px),rgba(250,250,250,1) calc(100vw - 237.5px)); */\n  /* background: linear-gradient(90deg, rgb(255 255 255) 0%, rgb(255 255 255) 33.33333%, rgb(250 250 250) 33.33333% , rgb(250 250 250) 50%, rgb(250 250 250) 50%, rgb(250 250 250) 66.66667%,rgba(11,173,127,1) 66.66667%, rgba(11,173,127,1) 83.44334%,rgba(250,250,250,1) 83.44334%);  */\n  }\n  }.accordion {\n  transition: background 0.6s ease;\n}.accordion .accordion-trigger:not(.no-action)::before,\n      .accordion .accordion-trigger:not(.no-action)::after {\n        content: \"\";\n        width: 14px;\n        height: 2px;\n        position: absolute;\n        right: 10px;\n        top: 16px;\n        transform: translate3d(0, -50%, 0);\n        transition: transform 0.2s ease;\n        backface-visibility: hidden;\n        z-index: 2;\n        --tw-bg-opacity: 1;\n        background-color: rgb(39 39 39 / var(--tw-bg-opacity));\n      }.accordion .accordion-trigger:not(.no-action)::after {\n        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 90deg);\n      }.accordion .accordion-trigger h2.reset-styles {\n      font-family: $gilroy;\n\n      @include fontFixPixel;\n\n      margin-bottom: 0;\n\n      margin-top: 0;\n\n      font-weight: 700;\n\n      line-height: 1.5;\n    }.accordion .accordion-trigger.reverse{\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  padding-left: 3rem;\n  padding-right: 1.25rem;\n  line-height: 1.25;\n}.accordion .accordion-trigger.reverse::before,\n      .accordion .accordion-trigger.reverse::after {\n        right: initial;\n        left: 1.5rem;\n        --tw-bg-opacity: 1;\n        background-color: rgb(157 166 186 / var(--tw-bg-opacity));\n      }.accordion .accordion-trigger.reverse.no-action{\n  padding-left: 1rem;\n}@media (min-width: 992px) {.accordion .accordion-trigger.reverse.no-action{\n    padding-left: 1.5rem;\n  }\n        }.accordion .accordion-image {\n    display: none;\n    right: 10%;\n  }.accordion .accordion-image.reverse {\n      left: 10%;\n      right: initial;\n    }.accordion .accordion-content a:not(.link){\n  --tw-text-opacity: 1;\n  color: rgb(10 118 58 / var(--tw-text-opacity));\n  text-decoration-line: underline;\n  color: #007d33;\n}.accordion .accordion-content a:not(.link):hover{\n  text-decoration-line: none;\n}.accordion.open{\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}.accordion.open .accordion-trigger::before {\n        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 0deg);\n      }.accordion.open .accordion-trigger::after {\n        transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 0deg);\n      }@media (min-width: 992px) {\n      .accordion.open .accordion-image {\n        display: block;\n        top: 50%;\n        transform: translate3d(0, -50%, 0);\n        animation: fadeIn 1s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;\n      }\n    }.accordion.open .chev-on .feather-chevron-down {\n        display: none !important;\n      }.accordion.open .chev-on .feather-chevron-up {\n        display: inline-block !important;\n      }.tronc-compare-wrapper {\n  border: 0 solid #e4e6eb;\n}#comparison-table .head {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    top: 85px;\n    z-index: 1;\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n  }@media (min-width: 576px) {#comparison-table .head {\n      padding-left: 1.25rem;\n      padding-right: 1.25rem;\n      top: 124px\n  }\n    }@media (min-width: 992px) {#comparison-table .head {\n      top: 94px\n  }\n    }#comparison-table .head .phorest-logo {\n      max-height: 60px;\n    }@media (min-width: 992px) {#comparison-table.competitor-var .head {\n        top: 110px\n    }\n      }#comparison-table .accordion-trigger {\n    /* stylelint-enable */\n  }/* stylelint-disable no-descending-specificity */#comparison-table .accordion-trigger p,\n    #comparison-table .accordion-trigger h3 {\n      margin-bottom: 0;\n      margin-left: 20px;\n    }#comparison-table .accordion.open .accordion-trigger.reverse::before,\n          #comparison-table .accordion.open .accordion-trigger.reverse::after{\n  --tw-bg-opacity: 1;\n  background-color: rgb(10 118 58 / var(--tw-bg-opacity));\n}#comparison-table .accordion.open .accordion-trigger.reverse .text-grey{\n  --tw-text-opacity: 1;\n  color: rgb(10 118 58 / var(--tw-text-opacity));\n  color: #007d33;\n}#comparison-table .accordion .accordion-trigger::before,\n      #comparison-table .accordion .accordion-trigger::after,\n      #comparison-table .accordion:not(.no-action)::before,\n      #comparison-table .accordion:not(.no-action)::after {\n        top: 37px;\n        left: 0;\n      }#comparison-table .accordion-content{\n  padding: 0;\n}#comparison-table .accordion-content > div {\n      border-bottom: 1px;\n      border-style: solid;\n      --tw-border-opacity: 1;\n      border-color: rgb(228 230 235 / var(--tw-border-opacity));\n    }#comparison-table .accordion-content > div:last-child {\n        border: none;\n      }#comparison-table .accordion-content > div svg {\n        margin: auto;\n        width: 21px;\n        height: 21px;\n        color: #fff;\n        padding: 4px;\n        stroke-width: 2px;\n        border-radius: 100%;\n        --tw-bg-opacity: 1;\n        background-color: rgb(15 97 93 / var(--tw-bg-opacity));\n\n      }.semi-circle-wrap.bg-transparent #comparison-table .accordion-content > div svg {\n    background-color: transparent;\n  }#comparison-table .accordion-content > div p {\n        /* stylelint-disable-line no-descending-specificity */\n        font-size: 13px;\n        margin-bottom: 0;\n        font-weight: 400;\n        line-height: 1.25;\n      }@media (min-width: 576px) {#comparison-table .accordion-content > div p {\n          font-size: 15px\n      }\n        }#comparison-table.compare-vs {\n    background: linear-gradient(270deg, #fff 50%, transparent 0%);\n  }@media (min-width: 992px) {#comparison-table.compare-vs {\n      top: 90px\n  }\n    }#comparison-table.compare-vs::before {\n      content: '';\n      height: calc(84% - 19px);\n      width: 19%;\n      left: 50%;\n      border: 2px solid #80d080;\n      position: absolute;\n      top: 15%;\n      z-index: 2;\n      border-radius: 5px;\n    }@media (min-width: 768px) {#comparison-table.compare-vs::before {\n        width: 24%;\n        height: calc(90% - 5px);\n        top: 10%\n    }\n      }@media (min-width: 992px){.lg\\:container{\n    width: 100%;\n    margin-right: auto;\n    margin-left: auto;\n  }@media (min-width: 576px){.lg\\:container{\n      max-width: 576px;\n    }\n  }@media (min-width: 768px){.lg\\:container{\n      max-width: 768px;\n    }\n  }@media (min-width: 992px){.lg\\:container{\n      max-width: 992px;\n    }\n  }@media (min-width: 1200px){.lg\\:container{\n      max-width: 1200px;\n    }\n  }\n}.hover\\:bg-red-light:hover{\n  --tw-bg-opacity: 1 !important;\n  background-color: rgb(252 150 139 / var(--tw-bg-opacity)) !important;\n}.hover\\:shadow-none:hover{\n  --tw-shadow: 0 0 #0000 !important;\n  --tw-shadow-colored: 0 0 #0000 !important;\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\n}.focus\\:not-sr-only:focus{\n  position: static !important;\n  width: auto !important;\n  height: auto !important;\n  padding: 0 !important;\n  margin: 0 !important;\n  overflow: visible !important;\n  clip: auto !important;\n  white-space: normal !important;\n}.group:hover .group-hover\\:inline-block{\n  display: inline-block !important;\n}.group:focus .group-focus\\:hidden{\n  display: none !important;\n}@media (min-width: 576px){.sm\\:mb-0{\n    margin-bottom: 0 !important;\n  }.sm\\:mr-4{\n    margin-right: 1rem !important;\n  }.sm\\:mr-5{\n    margin-right: 1.25rem !important;\n  }.sm\\:px-8{\n    padding-left: 2rem !important;\n    padding-right: 2rem !important;\n  }.sm\\:text-4xl{\n    font-size: 2.25rem !important;\n  }\n}@media (min-width: 768px){.md\\:ml-auto{\n    margin-left: auto !important;\n  }.md\\:mt-0{\n    margin-top: 0 !important;\n  }.md\\:w-1\\/3{\n    width: 33.33333% !important;\n  }.md\\:w-1\\/4{\n    width: 25% !important;\n  }.md\\:w-3\\/4{\n    width: 75% !important;\n  }.md\\:flex-none{\n    flex: none !important;\n  }.md\\:bg-transparent{\n    background-color: transparent !important;\n  }.md\\:p-4{\n    padding: 1rem !important;\n  }.md\\:py-12{\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }.md\\:pl-4{\n    padding-left: 1rem !important;\n  }.md\\:pt-0{\n    padding-top: 0 !important;\n  }.md\\:text-right{\n    text-align: right !important;\n  }.md\\:text-lg{\n    font-size: 1.125rem !important;\n  }\n}@media (min-width: 992px){.lg\\:static{\n    position: static !important;\n  }.lg\\:z-10{\n    z-index: 10 !important;\n  }.lg\\:z-20{\n    z-index: 20 !important;\n  }.lg\\:mb-10{\n    margin-bottom: 2.5rem !important;\n  }.lg\\:mb-2{\n    margin-bottom: 0.5rem !important;\n  }.lg\\:mr-5{\n    margin-right: 1.25rem !important;\n  }.lg\\:mt-0{\n    margin-top: 0 !important;\n  }.lg\\:block{\n    display: block !important;\n  }.lg\\:inline-block{\n    display: inline-block !important;\n  }.lg\\:flex{\n    display: flex !important;\n  }.lg\\:hidden{\n    display: none !important;\n  }.lg\\:w-1\\/2{\n    width: 50% !important;\n  }.lg\\:w-1\\/4{\n    width: 25% !important;\n  }.lg\\:w-1\\/5{\n    width: 20% !important;\n  }.lg\\:w-1\\/6{\n    width: 16.66667% !important;\n  }.lg\\:w-2\\/5{\n    width: 40% !important;\n  }.lg\\:w-2\\/6{\n    width: 33.33333% !important;\n  }.lg\\:w-auto{\n    width: auto !important;\n  }.lg\\:max-w-full{\n    max-width: 100% !important;\n  }.lg\\:border-none{\n    border-style: none !important;\n  }.lg\\:bg-grey-figma{\n    --tw-bg-opacity: 1 !important;\n    background-color: rgb(250 250 250 / var(--tw-bg-opacity)) !important;\n  }.lg\\:bg-transparent{\n    background-color: transparent !important;\n  }.lg\\:pb-0{\n    padding-bottom: 0 !important;\n  }.lg\\:pb-4{\n    padding-bottom: 1rem !important;\n  }.lg\\:pl-12{\n    padding-left: 3rem !important;\n  }.lg\\:pr-4{\n    padding-right: 1rem !important;\n  }.lg\\:pt-0{\n    padding-top: 0 !important;\n  }.lg\\:pt-4{\n    padding-top: 1rem !important;\n  }.lg\\:text-4xl{\n    font-size: 2.25rem !important;\n  }.lg\\:text-base{\n    font-size: 1rem !important;\n  }.lg\\:text-xl{\n    font-size: 1.25rem !important;\n  }.lg\\:font-semibold{\n    font-weight: 600 !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
